import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, Optional, Output, Renderer2, SimpleChanges, ViewChild, ChangeDetectorRef, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DriverService } from '@app/services/driver.service';
import { LocateDriverService } from '@app/services/locate-driver.service';
import { WarehouseService } from '@app/services/warehouse.service';
import { debounceTime, firstValueFrom, map, Observable, Subscription, timer, of } from 'rxjs';
import { GoogleMap, MapDirectionsService, MapTrafficLayer, MapInfoWindow } from '@angular/google-maps';
import { LoggingService } from '@app/services/logging.service';
import { environment } from 'src/environments/environment';
declare var google: {
  maps: {
    LatLng: any;
    Size: any;
    Point: any;
    DirectionsRenderer: any;
    DirectionsService: any;
    Marker: any;
    Map: any;
    LatLngBounds: any;
    DistanceMatrixService: any;
    UnitSystem: any;
    TravelMode: any;
    Geocoder: new () => any;
    places: { Autocomplete: new (arg0: any) => any };
    OverlayView: any;
    event: any;
  };
};
export interface DialogData {
  height: string;
  isShowDirections?: boolean;
  orderData?: any;
  driverData?: any;
  isComponent?: any;
  isDriverDetail?: any;
  showHeader?: boolean;
  customHeaderTitle?: string;
}
export interface MapDirectionsResponse {
  status: google.maps.DirectionsStatus;
  result?: google.maps.DirectionsResult;
}
import { LocateDriverWebsocketService } from '@app/services/locate-driver-websocket.service';

@Component({
  selector: 'app-reusable-google-map',
  templateUrl: './reusable-google-map.component.html',
  styleUrl: './reusable-google-map.component.scss'
})
export class ReusableGoogleMapComponent {
  private updateSubscription !: Subscription;
  private wsMainSubscription !: Subscription;
  private wsIndividualSubscription !: Subscription;
  title = 'ReusableGoogleMapComponent';
  showfirstDriver: any = 'Paul R';
  dummyDate: string = '';
  geoCoder: any;
  @Input() key !: number;
  @ViewChild('myModal') myModal!: ElementRef;
  initialCoordinates!: google.maps.LatLngLiteral;
  dialogData!: DialogData;
  @Input() height: any;
  @Input() isComponent: boolean = false;
  @Input() driverData: any;
  @Input() showHeader: boolean = false;
  @Input() customHeaderTitle: string = '';
  markerPositions: google.maps.LatLngLiteral[] = [];
  driverLocations: any;
  @Input() markerSize: number = 80;

  // Real-time Polyline Trimming State
  originalPoints: google.maps.LatLng[] = [];
  trimmedRoutePath: google.maps.LatLng[] = [];
  lastClosestIndex: number = 0;
  isOffRoute: boolean = false;
  offRouteCounter: number = 0;

  lat = 51.678418;
  lng = 7.809007;
  options: any;
  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true, // Completely disables all default Google UI (zoom, streetview, fullscreen, mapType)
    gestureHandling: 'greedy'
  };
  showTraffic: boolean = false;
  isSatellite: boolean = false;
  isFullscreen: boolean = false;
  isDarkMode: boolean = false;
  is3D: boolean = false;
  isAutoFollowPaused: boolean = false;
  hasInitialZoomSet: boolean = false;
  isUserZooming: boolean = false;
  currentFollowDriverId: string | null = null;
  isTrackingSessionExpired: boolean = false;
  private userZoomTimeout: any = null;
  private dragResumeTimeout: any = null;
  pausedDriverId: string | null = null;
  pausedDriverLabel: string | null = null;

  // Sleek Premium Dark Mode Theme for Maps
  darkModeStyles: google.maps.MapTypeStyle[] = [
    { elementType: "geometry", stylers: [{ color: "#212124" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#212124" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }] },
    { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
    { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
    { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
    { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#181818" }] },
    { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ color: "#1b1b1b" }] },
    { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] },
    { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] },
    { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] },
    { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] }
  ];
  @ViewChild(GoogleMap) map!: GoogleMap;
  markers: any = [];
  loadingMarkers: boolean = false;

  // Track backend running order and custom map visuals
  selectedDriverOrderData: any = null;
  // Owned exclusively by the individual socket — holds the full driver object
  // (name, profile_image, groups, is_online, running_order) for the selected driver.
  // Never read from allDrivers for bottom-sheet display; use this instead.
  selectedDriverDetail: any = null;
  currentDrawnOrderId: string | number | null = null;
  activeBackendPolyline: google.maps.Polyline | null = null;
  backendDestinationMarker: google.maps.Marker | null = null;
  backendDestinationOverlay: any = null;
  driver$: any;
  listOfDrivers: any = [];
  public directionsResults$!: Observable<google.maps.DirectionsResult | undefined>;
  estimatedTime: any;
  distance: any;
  directionsOptions: google.maps.DirectionsRendererOptions = {
    suppressMarkers: true,
    preserveViewport: false
  };
  private coordinateGroups: Map<string, number> = new Map();
  private driverLastUpdatedTime: Map<string, number> = new Map();
  // Persists the last known travel-direction heading per driver across all updates
  private driverLastHeading: Map<string, number> = new Map();
  private driverLastMoveTime: Map<string, number> = new Map();
  private driverLastDisplaySpeed: Map<string, number> = new Map();

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData, private locateDriverService: LocateDriverService, private dialog: MatDialog,
    private router: Router, private driverService: DriverService, private mapDirectionsService: MapDirectionsService,
    @Optional() public dialogRef: MatDialogRef<ReusableGoogleMapComponent>, public driverservice: DriverService, private renderer: Renderer2, public loggingService: LoggingService, private elRef: ElementRef, public warehouseService: WarehouseService, private locateDriverWsService: LocateDriverWebsocketService, private cdRef: ChangeDetectorRef, private ngZone: NgZone) {

  }
  directionsInterval: any
  driverId: any;
  destinationMarker?: google.maps.Marker;
  driverName: any;
  orderdetailss: any;
  showdriver: boolean = false;
  @Input() locatedriver: boolean = false;
  debugApiResponse: string = '';
  isManualSelection: boolean = false;
  isOfflineDriverSelected: boolean = false; // Tracks if the currently selected driver is offline — suppresses bottom sheet/tracking
  ngOnInit() {
    // 🔹 Wipe previous selections on page load for a clean state
    localStorage.removeItem('selectedDriverLabel');
    localStorage.removeItem('selectedDriverId');
    this.selectedDriverLabel = '';
    this.locateDriverids = null;
    if (typeof google !== 'undefined' && (google.maps as any).ControlPosition) {
      this.mapOptions = {
        ...this.mapOptions,
        disableDefaultUI: true, // Nuke the default UI again just to be 100% sure
        zoomControl: false,
        streetViewControl: true, // Re-enabled for the yellow Pegman
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControlOptions: {
          position: (google.maps as any).ControlPosition.RIGHT_BOTTOM
        },
        fullscreenControlOptions: {
          position: (google.maps as any).ControlPosition.RIGHT_BOTTOM
        },
        cameraControlOptions: {
          position: (google.maps as any).ControlPosition.RIGHT_BOTTOM
        },
        rotateControlOptions: {
          position: (google.maps as any).ControlPosition.RIGHT_BOTTOM
        }
      };
    }
    // this.warehouseList();
    // this.getCurrentLocation();
    this.dummyDate = this.getCurrentDate();
    if (this.data) {
      if (this.data.height) {
        this.height = this.data.height;
      }
      if (this.data.isDriverDetail == true) {
        this.showdriver = true;
        if (this.data.driverData) {
          this.selectedDriverLabel = (this.data.driverData.first_name || '') + ' ' + (this.data.driverData.last_name || '');
        }
      }
      if (this.data.isShowDirections) {
        this.orderdetailss = this.router.url.includes('receiving-admin');
        if (this.orderdetailss == false) {
          this.getDirections()
        }
        if (this.orderdetailss == true) {
          this.getDirections1()
        }
      }
      this.driverId = this.data.orderData?.current_driver?.id || this.data?.driverData?.id || 0;
      this.isComponent = this.data?.isComponent ?? this.isComponent;
      if (this.data?.showHeader !== undefined) {
        this.showHeader = this.data.showHeader;
      }
      if (this.data?.customHeaderTitle) {
        this.customHeaderTitle = this.data.customHeaderTitle;
      }
    }

    // for update the locate driver map without refresh
    //     this.locateDriverService.listenForUpdates();
    //      this.updateSubscription = this.locateDriverService.onUpdate().subscribe((driverUpdate) =>{
    //   if (!driverUpdate) return;
    //  if( driverUpdate.driver_id === this.locateDriverids)
    //   this.onDriverSelected1();
    //      })
    if (this.locatedriver) {
      const currentUrl = this.router.url;
      if (currentUrl.includes('admin') && !currentUrl.includes('receiving-admin')) {
        this.startListener();
        // ✅ CRITICAL: Set up wsMainSubscription + wsIndividualSubscription.
        // Without this call, no individual socket subscription exists, so
        // live bottom-sheet updates are silently dropped even when the socket fires.
        this.startWebsockets();
      }
      else if (currentUrl.includes('receiving-admin')) {
        this.receverListner();
      }
    }

    if (this.data && !this.locatedriver) {
      if ((this.data?.isShowDirections || this.data?.isDriverDetail) && this.driverId) {
        // Fetch initial values from API so UI populates instantly before socket connects
        this.driverservice.getDriverLocations(String(this.driverId)).subscribe((res: any) => {
          let driverInfo = null;

          if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
            driverInfo = res.data[0];
          } else if (res?.result?.results) {
            // Handle both Array (multi-driver) and Object (single-driver) responses
            driverInfo = Array.isArray(res.result.results) ? res.result.results[0] : res.result.results;
          }

          if (driverInfo) {
            if (driverInfo.running_order) {
              if (driverInfo.running_order.order_status?.toLowerCase().trim() === 'warehouse') {
                driverInfo.running_order.order_type = 'warehouse';
              }
              if (driverInfo.running_order.order_type) {
                driverInfo.running_order.order_type = driverInfo.running_order.order_type.trim();
              }
              this.hideBottomSheet = false;
              if (!this.selectedDriverOrderData) {
                this.selectedDriverOrderData = driverInfo.running_order;
                this.currentDrawnOrderId = driverInfo.running_order.order_id;
                if (this.data && this.data.orderData && driverInfo.running_order.order_status) {
                  this.data.orderData.order_status = driverInfo.running_order.order_status;
                }
              }
            } else {
              this.hideBottomSheet = true;
              this.clearBackendRoute();
            }

            // Fallback for immediate drawing: wait for Firebase to drop the marker (~500ms in ngAfterViewInit), 
            // then immediately draw the route using that marker's position instead of waiting for the socket ping.
            setTimeout(() => {
              this.drawDriverRouteFromBackend();
            }, 800);

            this.cdRef.detectChanges();
          }
        });
      }

      // Start Websockets
      this.startWebsockets();

      this.locateDriverService.listenForUpdates();
      this.updateSubscription = this.locateDriverService.onUpdate().pipe(
        debounceTime(300)
      ).subscribe((data) => {
        if (data) {
          // If this is a high-frequency RTDB update, update the marker directly
          if (data.isRTDB) {
            const name = this.getDriverName(data.driver_id) || "Driver";
            this.addMarker(data.location.latitude, data.location.longitude, data.driver_id, name, data.location.updatedTime, data.location.heading, data.location.speed);
            return;
          }
          if (this.data?.isDriverDetail) {
            this.getDriverLocationsFromFirebase();
          } else if (this.data?.orderData) {
            this.locateDriverService.getDriversInfo().then((res: any) => {
              if (res && res.length > 0) {
                let driverCurrentLocation = res.filter((element: any) => {
                  return String(element.driver_id) === String(this.data?.orderData?.current_driver?.id);
                });
                if (driverCurrentLocation && driverCurrentLocation.length > 0) {
                  const loc = driverCurrentLocation[0].location || driverCurrentLocation[0];
                  this.addMarkers(Number(loc.latitude), Number(loc.longitude), this.data.orderData.current_driver.id, this.getDriverFullName(this.data.orderData.current_driver), loc.updatedTime, loc.heading, loc.speed);
                }
              }
            });
          }
        }
      });
    }
    if (!this.height && !this.data?.height && this.isComponent) {
      this.height = '100%';
    }
  }

  toggleTraffic() {
    this.showTraffic = !this.showTraffic;
  }

  fitAllDrivers() {
    if (this.uniqueDriver && this.uniqueDriver.length > 0 && this.map?.googleMap) {
      const bounds = new google.maps.LatLngBounds();
      this.uniqueDriver.forEach((marker: any) => {
        if (marker.position && marker.position.lat && marker.position.lng) {
          bounds.extend(marker.position);
        }
      });
      this.map.googleMap.fitBounds(bounds);

      // Prevent zooming too far in if there's only one driver
      const listener = google.maps.event.addListener(this.map.googleMap, 'idle', () => {
        if (this.map.googleMap!.getZoom()! > 18) {
          this.map.googleMap!.setZoom(18);
        }
        google.maps.event.removeListener(listener);
      });
    }
  }

  ngOnDestroy(): void {
    this.cleanup();
  }
  timerSubscription!: Subscription;
  // 🔹 Firebase listener + 30 min timer start
  private startListener(): void {
    this.locateDriverService.listenForUpdates();

    this.updateSubscription = this.locateDriverService
      .onUpdate()
      .pipe(
        debounceTime(300) // 300ms wait karega
      )
      .subscribe((driverUpdate) => {
        if (!driverUpdate) return;

        console.log("📍 [MapComponent startListener] UPDATING MARKER FOR:", driverUpdate);

        // 🔹 Feed ALL Firebase updates (Firestore & RTDB) directly into the animation engine!
        // This ensures every truck on the map moves smoothly the instant its location changes, 
        // without waiting for the backend or calling any REST APIs.
        const name = this.getDriverName(driverUpdate.driver_id) || "Driver";
        if (driverUpdate.location && driverUpdate.location.latitude) {
          this.addMarker(
            driverUpdate.location.latitude,
            driverUpdate.location.longitude,
            driverUpdate.driver_id,
            name,
            driverUpdate.location.updatedTime,
            driverUpdate.location.heading,
            driverUpdate.location.speed
          );
        }
      });

    // ✅ Session timeout — pauses tracking and shows the "Resume" overlay
    this.timerSubscription = timer(environment.trackingSessionTimeoutMs).subscribe(() => {
      // 1. Remember the currently tracked driver
      this.pausedDriverId = this.locateDriverService['currentTrackedDriverId'];
      this.pausedDriverLabel = this.selectedDriverLabel;

      // 2. Stop Firebase watchers and WebSockets to save resources
      this.locateDriverService.stopActiveWatcher();
      this.locateDriverService.stopFirestoreListener();
      if (this.locateDriverWsService) {
        this.locateDriverWsService.disconnectAll();
      }

      if (this.updateSubscription) {
        this.updateSubscription.unsubscribe();
        this.updateSubscription = undefined!;
      }
      this.isTrackingSessionExpired = true;
      this.cdRef.detectChanges();
      console.log('⏸️ Tracking session paused — awaiting user action to resume');
    });
  }
  private receverListner(): void {
    const storedPayload = localStorage.getItem('companyDriverPayload');
    let companyDriverPayload = storedPayload ? JSON.parse(storedPayload) : [];

    // 🔹 2. Transform nested → flat
    const formattedPayload = companyDriverPayload.map((company: any) => ({
      company_id: company.company_id,
      driver_ids: company.driver_ids.map((d: any) => d[0]) // 👈 "14-31"
    }));

    this.locateDriverService.listenDriversByCompanies(formattedPayload);
    this.updateSubscription = this.locateDriverService
      .onUpdate()
      .pipe(
        debounceTime(300) // 300ms wait karega
      )
      .subscribe((driverUpdate) => {
        if (!driverUpdate) return;

        // 🔹 Feed ALL Firebase updates (Firestore & RTDB) directly into the animation engine!
        // This ensures every truck on the map moves smoothly the instant its location changes, 
        // without waiting for the backend or calling any REST APIs.
        const name = this.getDriverName(driverUpdate.driver_id) || "Driver";
        if (driverUpdate.location && driverUpdate.location.latitude) {
          this.addMarker(
            driverUpdate.location.latitude,
            driverUpdate.location.longitude,
            driverUpdate.driver_id,
            name,
            driverUpdate.location.updatedTime,
            driverUpdate.location.heading,
            driverUpdate.location.speed
          );
        }
      });

    // ✅ Session timeout — pauses tracking and shows the "Resume" overlay
    this.timerSubscription = timer(environment.trackingSessionTimeoutMs).subscribe(() => {
      // 1. Remember the currently tracked driver
      this.pausedDriverId = this.locateDriverService['currentTrackedDriverId'];
      this.pausedDriverLabel = this.selectedDriverLabel;

      // 2. Stop Firebase watchers and WebSockets to save resources
      this.locateDriverService.stopActiveWatcher();
      this.locateDriverService.stopFirestoreListener();
      if (this.locateDriverWsService) {
        this.locateDriverWsService.disconnectAll();
      }

      if (this.updateSubscription) {
        this.updateSubscription.unsubscribe();
        this.updateSubscription = undefined!;
      }
      this.isTrackingSessionExpired = true;
      this.cdRef.detectChanges();
      console.log('⏸️ Tracking session paused — awaiting user action to resume');
    });
  }

  // 🔹 Cleanup subscriptions
  private cleanup(): void {
    this.isTrackingSessionExpired = false;
    if (this.locateDriverService) {
      this.locateDriverService.stopActiveWatcher();
      this.locateDriverService.stopFirestoreListener();
    }
    if (this.locateDriverWsService) {
      this.locateDriverWsService.disconnectAll();
    }
    if (this.updateSubscription) {
      this.updateSubscription.unsubscribe();
      this.updateSubscription = undefined!;
    }
    if (this.wsMainSubscription) {
      this.wsMainSubscription.unsubscribe();
      this.wsMainSubscription = undefined!;
    }
    if (this.wsIndividualSubscription) {
      this.wsIndividualSubscription.unsubscribe();
      this.wsIndividualSubscription = undefined!;
    }
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = undefined!;
    }
  }

  startWebsockets() {
    if (this.locatedriver) {
      const currentUrl = this.router.url;
      if (currentUrl.includes('admin') && !currentUrl.includes('receiving-admin')) {
        // Connect Main Socket
        this.locateDriverWsService.connectMainSocket();

        // Subscribe to Main Socket Updates
        this.wsMainSubscription = this.locateDriverWsService.onMainUpdate().subscribe((drivers: any[]) => {
          if (drivers) {
            this.allDrivers = drivers;
            if (this.filterType === 'online') {
              this.listOfDrivers = this.allDrivers.filter(d => d.is_online === true);
            } else if (this.filterType === 'offline') {
              this.listOfDrivers = this.allDrivers.filter(d => d.is_online === false);
            } else if (this.filterType === 'pending') {
              this.listOfDrivers = this.allDrivers.filter(d => !d.drivertime?.length);
            } else {
              this.listOfDrivers = this.allDrivers;
            }
            this.driversUpdated.emit(this.allDrivers);
            localStorage.setItem("locatedriversList", JSON.stringify(this.listOfDrivers));

            // Re-apply visually after background update
            this.applyFilterVisually();
          }
        });

        // Subscribe to Individual Socket Updates
        // Individual socket owns: selectedDriverDetail (full driver) + selectedDriverOrderData (running_order)
        // Do NOT mix with allDrivers (main socket) for bottom-sheet display.
        this.wsIndividualSubscription = this.locateDriverWsService.onIndividualUpdate().subscribe((driver: any) => {
          if (driver) {
            console.log("Individual Driver WS Update Received:", driver);

            // The individual socket emits data.result.results = single driver object { id, ... }
            // The trackingId guard is a safety net; the socket is already filtered by driver on the URL.
            const trackingId = this.currentFollowDriverId || (this.locateDriverids ? String(this.locateDriverids) : null);
            if (!trackingId || trackingId === String(driver.id)) {
              // ✅ Store full driver object — used exclusively by bottom-sheet getters
              this.selectedDriverDetail = driver;

              if (driver.running_order) {
                if (driver.running_order.order_status?.toLowerCase().trim() === 'warehouse') {
                  driver.running_order.order_type = 'warehouse';
                }
                if (driver.running_order.order_type) {
                  driver.running_order.order_type = driver.running_order.order_type.trim();
                }
                this.hideBottomSheet = false;
                this.selectedDriverOrderData = driver.running_order;
                if (this.currentDrawnOrderId !== driver.running_order.order_id) {
                  this.currentDrawnOrderId = driver.running_order.order_id;
                  this.drawDriverRouteFromBackend();
                }
              } else {
                this.selectedDriverOrderData = null;
                this.currentDrawnOrderId = null;
                this.hideBottomSheet = true;
                this.clearBackendRoute();
              }
              this.cdRef.detectChanges();
            }
          }
        });
      }
    } else if (this.data && !this.locatedriver) {
      if ((this.data?.isShowDirections || this.data?.isDriverDetail) && this.driverId) {
        this.locateDriverWsService.connectIndividualSocket(String(this.driverId));
        this.wsIndividualSubscription = this.locateDriverWsService.onIndividualUpdate().subscribe((driver: any) => {
          if (driver) {
            this.selectedDriverDetail = driver;

            if (driver.running_order) {
              // ✅ ORDER ID GUARD: Only show bottom sheet data for the specific order
              // this modal was opened for. If the driver has moved to a new order,
              // treat it as idle — hide sheet and clear markers.
              // ⚠️ WAREHOUSE EXCEPTION: Warehouse-type orders always have a different order_id
              // than the parent delivery/pickup order (they are transitional legs), so we
              // bypass the guard for them — they are always part of the driver's current assignment.
              const openedOrderId = this.data?.orderData?.id;
              const socketOrderId = driver.running_order?.order_id;
              const isWarehouseLeg = driver.running_order?.order_type?.toLowerCase().trim() === 'warehouse' ||
                driver.running_order?.order_status?.toLowerCase().trim() === 'warehouse';
              const orderMismatch = this.data?.isShowDirections && openedOrderId && socketOrderId &&
                String(openedOrderId) !== String(socketOrderId) && !isWarehouseLeg;

              if (orderMismatch) {
                // Driver is on a different order — hide everything for this modal
                this.selectedDriverOrderData = null;
                this.currentDrawnOrderId = null;
                this.hideBottomSheet = true;
                this.clearBackendRoute();
              } else {
                if (driver.running_order.order_status?.toLowerCase().trim() === 'warehouse') {
                  driver.running_order.order_type = 'warehouse';
                }
                if (driver.running_order.order_type) {
                  driver.running_order.order_type = driver.running_order.order_type.trim();
                }
                this.hideBottomSheet = false;
                this.selectedDriverOrderData = driver.running_order;
                if (this.data && this.data.orderData) {
                  this.data.orderData.order_status = driver.running_order?.order_status;
                }

                if (this.currentDrawnOrderId !== driver.running_order?.order_id) {
                  this.currentDrawnOrderId = driver.running_order?.order_id;
                  const socketDriverLoc = (driver.latitude && driver.longitude) ? { lat: Number(driver.latitude), lng: Number(driver.longitude) } : undefined;
                  this.drawDriverRouteFromBackend(socketDriverLoc);
                }
              }
            } else {
              this.selectedDriverOrderData = null;
              this.currentDrawnOrderId = null;
              this.hideBottomSheet = true;
              this.clearBackendRoute();
            }
            this.cdRef.detectChanges();
          }
        });
      }
    }
  }

  // 🔹 Resume tracking after session timeout overlay
  resumeTrackingSession(): void {
    this.isTrackingSessionExpired = false;

    // 🔹 CRITICAL: Clear the deduplication timestamp cache from the previous session.
    // Without this, addMarker silently rejects every RTDB update because the stale
    // RTDB timestamps (milliseconds) from the old session are always newer than the
    // preserved Firestore updatedTime (seconds*1000), causing addMarker to return early.
    this.driverLastUpdatedTime.clear();

    this.resetListener();
    this.startWebsockets(); // Resurrect Main WebSocket

    // 🔹 Restore the specific driver RTDB watcher + Individual WebSocket if there was one
    const activeDriverToTrack = this.currentFollowDriverId || this.locateDriverids || this.pausedDriverId;
    if (activeDriverToTrack) {
      const driverName = this.getDriverName(activeDriverToTrack) || this.pausedDriverLabel || 'Unknown Driver';
      this.locateDriverService.startActiveWatcher(String(activeDriverToTrack), driverName);

      // 🔹 Reconnect the individual driver socket so the bottom sheet order info keeps updating
      this.locateDriverWsService.connectIndividualSocket(String(activeDriverToTrack));
    }

    this.pausedDriverId = null;
    this.pausedDriverLabel = null;
    console.log('▶️ Tracking session resumed by user');
  }

  // 🔹 Parent ya button se reset ke liye
  resetListener(): void {
    this.cleanup();
    const currentUrl = this.router.url;
    if (currentUrl.includes('admin') && !currentUrl.includes('receiving-admin')) {
      this.startListener();
    }
    else if (currentUrl.includes('receiving-admin')) {
      this.receverListner();
    }
    console.log('🔄 Listener & timer reset from parent or refresh button');
  }
  warehouse$!: Observable<object[]>;
  warehouseData: any;
  center: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  warehouseList(page?: any) {
    this.warehouseService.warehouseList(page);
    this.warehouse$ = this.warehouseService.getWarehouse();

    this.warehouse$.subscribe((data: any) => {
      this.warehouseData = data?.result?.results;
      const mainWarehouse = this.warehouseData.find(
        (w: any) => w.is_main_localation === true
      );

      if (mainWarehouse) {
        this.center = {
          lat: parseFloat(mainWarehouse.address.latitude),
          lng: parseFloat(mainWarehouse.address.longitude),
        };
      }
    });
  }

  pauseFollowForUserZoom(): void {
    this.isUserZooming = true;
    if (this.userZoomTimeout) {
      clearTimeout(this.userZoomTimeout);
    }
    this.userZoomTimeout = setTimeout(() => {
      this.isUserZooming = false;
    }, 1000);
  }

  onMapWheel(event?: WheelEvent): void {
    this.pauseFollowForUserZoom();
  }

  onMapZoomChanged(): void {
    this.pauseFollowForUserZoom();
  }

  onMapDragStart(): void {
    this.isAutoFollowPaused = true;
    this.pauseFollowForUserZoom();
    if (this.dragResumeTimeout) {
      clearTimeout(this.dragResumeTimeout);
    }
  }

  onMapDragEnd(): void {
    if (this.dragResumeTimeout) {
      clearTimeout(this.dragResumeTimeout);
    }
    // Automatically resume following after 5 seconds of inactivity so truck is never lost
    this.dragResumeTimeout = setTimeout(() => {
      this.isAutoFollowPaused = false;
    }, 5000);
  }

  // 🔹 Custom Zoom Controls
  zoomIn() {
    this.pauseFollowForUserZoom();
    if (this.map && this.map.googleMap) {
      const currentZoom = this.map.googleMap.getZoom() || 12;
      this.map.googleMap.setZoom(currentZoom + 1);
    }
  }

  zoomOut() {
    this.pauseFollowForUserZoom();
    if (this.map && this.map.googleMap) {
      const currentZoom = this.map.googleMap.getZoom() || 12;
      this.map.googleMap.setZoom(currentZoom - 1);
    }
  }

  toggleMapType() {
    this.isSatellite = !this.isSatellite;
    if (this.map && this.map.googleMap) {
      this.map.googleMap.setMapTypeId(this.isSatellite ? 'satellite' : 'roadmap');
    }
  }

  toggleDarkMode() {
    this.isDarkMode = !this.isDarkMode;
    if (this.map && this.map.googleMap) {
      this.map.googleMap.setOptions({ styles: this.isDarkMode ? this.darkModeStyles : [] });
    }
  }

  toggle3D() {
    this.is3D = !this.is3D;
    if (this.map && this.map.googleMap) {
      this.map.googleMap.setTilt(this.is3D ? 45 : 0);

      if (this.is3D) {
        // Force zoom in, as Google Maps requires Zoom Level >= 18 to show 3D/45-degree tilt
        if ((this.map.googleMap.getZoom() || 0) < 18) {
          this.map.googleMap.setZoom(18);
        }

        // Force satellite mode, as 3D tilt imagery is only available in Satellite view
        if (!this.isSatellite) {
          this.toggleMapType();
        }
      }
    }
  }

  toggleFullscreen() {
    const fullScreenContainer = this.elRef.nativeElement.querySelector('.full-height-tracker');
    if (!document.fullscreenElement) {
      if (fullScreenContainer.requestFullscreen) {
        fullScreenContainer.requestFullscreen().then(() => {
          this.isFullscreen = true;
        }).catch((err: any) => {
          console.error(`Error attempting to enable fullscreen: ${err.message}`);
        });
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          this.isFullscreen = false;
        });
      }
    }
  }

  getCustomIcon(type: string): any {
    const currentDate = new Date();
    return `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  }
  getCurrentDate(): string {
    const currentDate = new Date();
    return `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
  }
  ngAfterViewInit() {
    // 🔹 Start RTDB tracking if modal is open for a specific driver or order tracking
    if ((this.showdriver || this.data?.isDriverDetail || this.data?.isShowDirections) && this.driverId) {
      let watcherName = this.getDriverName(this.driverId) || 'Unknown Driver';
      if (this.data?.isShowDirections) {
        const adminName = localStorage.getItem('user_name') || localStorage.getItem('first_name') || 'Admin';
        watcherName = `Admin: ${adminName}`;
      }
      this.locateDriverService.startActiveWatcher(String(this.driverId), watcherName);
    }

    const currentUrl = this.router.url;
    if (currentUrl.includes('admin') && !currentUrl.includes('receiving-admin')) {
      setTimeout(() => {
        // Trigger data fetch if we are showing a specific driver (Modal or Component)
        if (this.locatedriver) {
          this.onDriverSelected1(true);
        } else if (this.isComponent || this.showdriver || this.data?.driverData) {
          this.getDriverLocationsFromFirebase();
        }

        if (this.data && this.data.isComponent && !this.locatedriver) {
          this.getDriverLocationsFromFirebase();
        }

      }, 500);

    }
    else if (currentUrl.includes('receiving-admin')) {
      setTimeout(() => {
        this.onDriverSelectedLocal();
      }, 500);
    }

  }
  ngOnChanges(changes: SimpleChanges) {

    if (changes['filterType'] && !changes['filterType'].firstChange) {
      console.log('Filter Changed:', this.filterType);
      this.isManualSelection = false;

      // 🔹 STICKY SELECTION: Only clear the selection if the tracked driver no longer matches the active filter
      let shouldClear = true;
      if (this.locateDriverids && this.allDrivers) {
        const trackedDriver = this.allDrivers.find((d: any) => String(d.id) === String(this.locateDriverids));
        if (trackedDriver) {
          const isOnline = trackedDriver.is_online === true;
          if (this.filterType === 'all') {
            shouldClear = false;
          } else if (this.filterType === 'online' && isOnline) {
            shouldClear = false;
          } else if (this.filterType === 'offline' && !isOnline) {
            shouldClear = false;
          }
        }
      }

      if (shouldClear) {
        this.clearDriverSelection(); // Wipe out active bottom sheets and destination markers when switching tabs
      }

      if (this.locatedriver) {
        // 🔹 Step 1: Instant visual filter from cached data (no API calls, no blank map)
        this.applyFilterVisually();

        // 🔹 Step 2: Silent background refresh to catch any status changes
        const currentUrl = this.router.url;
        if (currentUrl.includes('admin') && !currentUrl.includes('receiving-admin')) {
          this.onDriverSelected1(false);
        }
        else if (currentUrl.includes('receiving-admin')) {
          this.onDriverSelectedLocal(false);
        }
      } else {
        // For single driver tracking, use singular refresh
        this.getDriverLocationsFromFirebase();
      }
    }
  }
  openModal(event: Event) {
    //event.preventDefault();
    // Open Bootstrap modal using jQuery (ensure that Bootstrap JS is loaded)
    // Note: Ensure that you've imported 'declare var $: any;' in your component or globally
    this.renderer.addClass(this.myModal?.nativeElement, 'show');
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
  }

  closeModal() {
    // Close Bootstrap modal using jQuery
    this.renderer.removeClass(this.myModal?.nativeElement, 'show');
    this.renderer.removeStyle(document.body, 'overflow');
  }

  getDirections() {
    this.locateDriverService.getDriversInfo().then((res: any) => {
      if (res && res.length > 0) {
        let driverCurrentLocation = res.filter((element: any) => {
          return element.driver_id == this.data?.orderData?.current_driver?.id
        });

        if (driverCurrentLocation && driverCurrentLocation.length > 0) {
          if (this.data.orderData.order_type == 'delivery') {
            const request: google.maps.DirectionsRequest = {
              destination: { lat: Number(this.data.orderData.dely_address.latitude), lng: Number(this.data.orderData.dely_address.longitude) },
              origin: { lat: Number(driverCurrentLocation[0].location.latitude), lng: Number(driverCurrentLocation[0].location.longitude) },
              travelMode: google?.maps?.TravelMode?.DRIVING,
              unitSystem: google.maps.UnitSystem.METRIC,
              avoidHighways: false,
              avoidTolls: false,
              provideRouteAlternatives: true,
            };
            this.mapDirectionsService.route(request).subscribe((response: any) => {
              if (response && response.result && response.result.routes && response.result.routes.length > 0) {
                this.originalPoints = response.result.routes[0].overview_path;
                this.trimmedRoutePath = [...this.originalPoints];
              }
              this.cdRef.detectChanges();
            });
            this.getDistance(request?.origin, "", request?.destination, "");
            this.addMarkers(Number(driverCurrentLocation[0].location.latitude), Number(driverCurrentLocation[0].location.longitude), this.data.orderData.current_driver.id, this.getDriverFullName(this.data.orderData.current_driver));
            this.setDestinationMarker(request.destination);
          }
          if (this.data.orderData.order_type == 'pickup') {
            const request: google.maps.DirectionsRequest = {
              destination: { lat: Number(this.data.orderData.pickup_address.latitude), lng: Number(this.data.orderData.pickup_address.longitude) },
              origin: { lat: Number(driverCurrentLocation[0].location.latitude), lng: Number(driverCurrentLocation[0].location.longitude) },
              travelMode: google?.maps?.TravelMode?.DRIVING,
              unitSystem: google.maps.UnitSystem.METRIC,
              avoidHighways: false,
              avoidTolls: false,
              provideRouteAlternatives: true
            };
            this.mapDirectionsService.route(request).subscribe((response: any) => {
              if (response && response.result && response.result.routes && response.result.routes.length > 0) {
                this.originalPoints = response.result.routes[0].overview_path;
                this.trimmedRoutePath = [...this.originalPoints];
              }
              this.cdRef.detectChanges();
            });
            this.getDistance(request?.origin, "", request?.destination, "");
            // this.driverList(this.data.orderData.current_driver.id);
            this.addMarkers(Number(driverCurrentLocation[0].location.latitude), Number(driverCurrentLocation[0].location.longitude), this.data.orderData.current_driver.id, this.getDriverFullName(this.data.orderData.current_driver));
            this.setDestinationMarker(request.destination);
          }
          if (this.data.orderData.order_type == 'warehouse') {
            const request: google.maps.DirectionsRequest = {
              destination: { lat: Number(this.data.orderData.dely_address.latitude), lng: Number(this.data.orderData.dely_address.longitude) },
              origin: { lat: Number(driverCurrentLocation[0].location.latitude), lng: Number(driverCurrentLocation[0].location.longitude) },
              travelMode: google?.maps?.TravelMode?.DRIVING,
              unitSystem: google.maps.UnitSystem.METRIC,
              avoidHighways: false,
              avoidTolls: false,
              provideRouteAlternatives: true,
            };
            this.mapDirectionsService.route(request).subscribe((response: any) => {
              if (response && response.result && response.result.routes && response.result.routes.length > 0) {
                this.originalPoints = response.result.routes[0].overview_path;
                this.trimmedRoutePath = [...this.originalPoints];
              }
              this.cdRef.detectChanges();
            });
            this.getDistance(request?.origin, "", request?.destination, "");
            this.addMarkers(Number(driverCurrentLocation[0].location.latitude), Number(driverCurrentLocation[0].location.longitude), this.data.orderData.current_driver.id, this.getDriverFullName(this.data.orderData.current_driver));
            this.setDestinationMarker(request.destination);
            //  this.addMarkersss(Number(Number(this.data.orderData.dely_address.latitude)),Number(this.data.orderData.dely_address.longitude));
          }

        }
      }
    });

  }
  getDirections1() {
    const driverCurrentLocation = this.data.orderData.current_driver.drivertime
    if (driverCurrentLocation && driverCurrentLocation.length > 0) {
      if (this.data.orderData.order_type == 'delivery') {
        const request: google.maps.DirectionsRequest = {
          destination: { lat: Number(this.data.orderData.dely_address.latitude), lng: Number(this.data.orderData.dely_address.longitude) },
          origin: { lat: Number(driverCurrentLocation[0].latitude), lng: Number(driverCurrentLocation[0].longitude) },
          travelMode: google?.maps?.TravelMode?.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
          provideRouteAlternatives: true,
        };
        this.mapDirectionsService.route(request).subscribe((response: any) => {
          if (response && response.result && response.result.routes && response.result.routes.length > 0) {
            this.originalPoints = response.result.routes[0].overview_path;
            this.trimmedRoutePath = [...this.originalPoints];
          }
          this.cdRef.detectChanges();
        });
        this.getDistance(request?.origin, "", request?.destination, "");
        this.addMarkers(Number(driverCurrentLocation[0].latitude), Number(driverCurrentLocation[0].longitude), this.data.orderData.current_driver.id, this.getDriverFullName(this.data.orderData.current_driver));
        this.setDestinationMarker(request.destination);
      }
      if (this.data.orderData.order_type == 'pickup') {
        const request: google.maps.DirectionsRequest = {
          destination: { lat: Number(this.data.orderData.pickup_address.latitude), lng: Number(this.data.orderData.pickup_address.longitude) },
          origin: { lat: Number(driverCurrentLocation[0].latitude), lng: Number(driverCurrentLocation[0].longitude) },
          travelMode: google?.maps?.TravelMode?.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
          provideRouteAlternatives: true
        };
        this.mapDirectionsService.route(request).subscribe((response: any) => {
          if (response && response.result && response.result.routes && response.result.routes.length > 0) {
            this.originalPoints = response.result.routes[0].overview_path;
            this.trimmedRoutePath = [...this.originalPoints];
          }
          this.cdRef.detectChanges();
        });
        this.getDistance(request?.origin, "", request?.destination, "");
        // this.driverList(this.data.orderData.current_driver.id);
        this.addMarkers(Number(driverCurrentLocation[0].latitude), Number(driverCurrentLocation[0].longitude), this.data.orderData.current_driver.id, this.getDriverFullName(this.data.orderData.current_driver));
        this.setDestinationMarker(request.destination);
      }
      if (this.data.orderData.order_type == 'warehouse') {
        const request: google.maps.DirectionsRequest = {
          destination: { lat: Number(this.data.orderData.dely_address.latitude), lng: Number(this.data.orderData.dely_address.longitude) },
          origin: { lat: Number(driverCurrentLocation[0].latitude), lng: Number(driverCurrentLocation[0].longitude) },
          travelMode: google?.maps?.TravelMode?.DRIVING,
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
          provideRouteAlternatives: true,
        };
        this.mapDirectionsService.route(request).subscribe((response: any) => {
          if (response && response.result && response.result.routes && response.result.routes.length > 0) {
            this.originalPoints = response.result.routes[0].overview_path;
            this.trimmedRoutePath = [...this.originalPoints];
          }
          this.cdRef.detectChanges();
        });
        this.getDistance(request?.origin, "", request?.destination, "");
        this.addMarkers(Number(driverCurrentLocation[0].latitude), Number(driverCurrentLocation[0].longitude), this.data.orderData.current_driver.id, this.getDriverFullName(this.data.orderData.current_driver));
        this.setDestinationMarker(request.destination);
        //  this.addMarkersss(Number(Number(this.data.orderData.dely_address.latitude)),Number(this.data.orderData.dely_address.longitude));
      }

    }

  }
  onDismiss() {
    this.dialogRef.close();
  }

  getDriverLocationsFromFirebase() {
    this.locateDriverService.getDriversInfo().then((res: any) => {
      this.coordinateGroups.clear(); // Reset collision tracker before update
      this.driverLocations = res;
      const driverData = this.data?.driverData || this.driverData;

      if (driverData) {
        const dId = String(driverData.id || driverData.driver_id);
        let element = this.driverLocations.find((el: any) => {
          return String(el.driver_id) === dId;
        });

        if (element) {
          let name = (driverData.first_name || '') + " " + (driverData.last_name || '');
          if (!name.trim()) name = element.name || 'Driver';

          // 🔹 FILTER LOGIC: Skip drivers that don't match the current filterType
          let matchesFilter = true;
          if (this.filterType === 'online') matchesFilter = driverData?.is_online === true;
          else if (this.filterType === 'offline') matchesFilter = driverData?.is_online === false;
          else if (this.filterType === 'pending') matchesFilter = !driverData?.drivertime?.length;

          if (this.filterType === 'all' || matchesFilter) {
            this.addMarker(
              element.location.latitude,
              element.location.longitude,
              element.driver_id,
              name,
              element.location.updatedTime,
              element.location.heading,
              element.location.speed
            );
          }

          if (this.showdriver) {
            const lat = Number(element.location.latitude);
            const lng = Number(element.location.longitude);
            this.center = { lat, lng };

            // Force map center if ready
            if (this.map?.googleMap) {
              this.map.googleMap.setCenter(this.center);
              if (!this.hasInitialZoomSet) {
                this.map.googleMap.setZoom(18);
                this.hasInitialZoomSet = true;
              }
            }
          }
        } else {
          console.warn('Driver not found in Firebase locations:', dId);
          // Fallback to manual marker if firebase loc not found but we have some loc?
          this.driverList();
        }

        this.myFunction(this.title, 'getDriverLocationsFromFirebase');
      } else {
        this.driverList();
      }
    });
  }

  getCurrentLocation() {
    this.geoCoder = new google.maps.Geocoder();
    if (!(this.driverLocations && this.driverLocations.length > 0)) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.initialCoordinates = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    }
    this.myFunction(this.title, 'geoCoder');

  }
  formatFirebaseStyle(ts: any): string {
    const date = new Date(ts.seconds * 1000 + ts.nanoseconds / 1_000_000);

    // Options for month name
    const month = date.toLocaleString("en-US", { month: "long" });
    const day = date.getDate();
    const year = date.getFullYear();

    // Time in 12-hour format
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // convert 0 to 12

    // Timezone (IST)
    const timezone = "UTC+5:30";

    return `${month} ${day}, ${year} at ${hours}:${minutes}:${seconds} ${ampm} ${timezone}`;
  }
  topDriverId: any
  @Output() driversUpdated = new EventEmitter<any[]>();
  @Output() refreshLocationClicked = new EventEmitter<void>();

  onRefreshClicked() {
    this.refreshLocationClicked.emit();
  }
  @Input() filterType: string = 'all';
  companiesData: any[] = [];
  allDrivers: any[] = [];
  driverList(id?: number) {
    localStorage.removeItem("locatedriversList");
    this.driverService.driverList2(id);
    this.driver$ = this.driverService.getDrivers();

    this.driver$.subscribe((data: any) => {
      if (data && data.result && data.result.results) {
        this.allDrivers = data.result.results;
        // this.listOfDrivers = data.result.results;
        if (this.filterType === 'online') {
          this.listOfDrivers = this.allDrivers.filter(d =>
            d.is_online === true
          );
          localStorage.setItem("locatedriversList", JSON.stringify(this.listOfDrivers));
        }

        else if (this.filterType === 'offline') {
          this.listOfDrivers = this.allDrivers.filter(d =>
            d.is_online === false
          );
          localStorage.setItem("locatedriversList", JSON.stringify(this.listOfDrivers));
        }

        else if (this.filterType === 'pending') {
          this.listOfDrivers = this.allDrivers.filter(d =>
            !d.drivertime?.length
          );
          localStorage.setItem("locatedriversList", JSON.stringify(this.listOfDrivers));
        }
        else if (this.filterType === 'all') {
          this.listOfDrivers = data.result.results;
          localStorage.setItem("locatedriversList", JSON.stringify(this.listOfDrivers));
        }
        this.driversUpdated.emit(this.allDrivers);
      }

      if (this.driverLocations && this.driverLocations.length > 0) {
        for (let index = 0; index < this.driverLocations.length; index++) {
          const name = this.getDriverName(this.driverLocations[index].driver_id);
          this.driverLocations[index]['name'] = name;
        }

        setTimeout(() => {
          this.driverLocations.forEach((element: any) => {
            if (element.location && element.name.toString().length != 0) {
              this.addMarker(
                element.location.latitude,
                element.location.longitude,
                element.driver_id,
                element.name,
                element.location.updatedTime,
                element.location.heading,
                element.location.speed
              );
              // 👉 pehle driver ko default select karo
              // if (element.driver_id === this.listOfDrivers[0].id) {
              //   this.selectedDriverLabel = this.listOfDrivers[0].is_online
              //     ? element.name
              //     : `${element.name} (Offline)`;
              //   this.center = {
              //     lat: element.location.latitude,
              //     lng: element.location.longitude,
              //   };
              // }
              // 👉 localStorage se saved driver label lo
              const savedDriverLabel = localStorage.getItem('selectedDriverLabel');

              let selectedIndex = -1;

              if (savedDriverLabel) {

                // 👉 First word nikal lo (firstname)
                const savedFirstName = savedDriverLabel.split(' ')[0];

                // 👉 listOfDrivers me match karo first_name se
                selectedIndex = this.listOfDrivers.findIndex((driver: { first_name: string; }) =>
                  driver.first_name === savedFirstName
                );
              }

              // 👉 Agar match mil gaya
              if (selectedIndex !== -1) {

                const matchedDriver = this.listOfDrivers[selectedIndex];

                if (element.driver_id === matchedDriver.id) {

                  this.selectedDriverLabel = matchedDriver.is_online
                    ? element.name
                    : `${element.name} (Offline)`;

                  this.center = {
                    lat: element.location.latitude,
                    lng: element.location.longitude,
                  };
                  localStorage.setItem('selectedDriverLabel', this.selectedDriverLabel);
                }
                this.topDriverId = matchedDriver.id;

              } else {

                // 👉 Agar localStorage me kuch nahi mila ya match nahi mila
                if (element.driver_id === this.listOfDrivers[0].id) {

                  this.selectedDriverLabel = this.listOfDrivers[0].is_online
                    ? element.name
                    : `${element.name} (Offline)`;

                  this.center = {
                    lat: element.location.latitude,
                    lng: element.location.longitude,
                  };
                  this.topDriverId = this.listOfDrivers[0]?.id;
                  localStorage.setItem('selectedDriverLabel', this.selectedDriverLabel);
                }
              }
            }
          });

          // ✅ Ab sab markers add ho chuke, zIndex logic yahan lagao
          this.markers.forEach((marker: any) => {
            marker.options = {
              ...marker.options,
              zIndex: 1, // default
            };
          });

          const topDriverId = this.topDriverId;// pehla driver
          if (topDriverId) {
            const topMarker = this.markers.find((marker: any) => marker.id === topDriverId);
            if (topMarker) {
              topMarker.options = {
                ...topMarker.options,
                zIndex: 999,
              };
            }
          }
        }, 1000);

      }
    });

  }
  selectedDriver: any;
  uniqueDriver: any;
  // addMarker(latitude:any, long:any, id:any,name:string) {
  //   let cord = {lat: latitude, lng: long}
  //   let deactiveicon =localStorage.getItem('');
  //   if(cord){
  //     this.markers.push(
  //       {
  //         id: id,
  //         position : cord,
  //         label: {
  //           color: '#0eb002',
  //           text: name?name.toString() : '',
  //           className: 'marker-label1',
  //           fontWeight: 'bold',
  //           labelClass: "marker-label1", // your desired CSS class
  //         },
  //         options: {
  //           icon: 'assets/images/map-icon.png'
  //         }
  //       }
  //     )
  //   }
  //   // if(cord){
  //   //   this.markers.push(
  //   //     {
  //   //       id: id,
  //   //       position : cord,
  //   //       label: {
  //   //         color: 'grey',
  //   //         text: name?name.toString() + "(Offline)" : '',
  //   //         className: 'marker-label2',
  //   //         fontWeight: 'bold',
  //   //         labelClass: "marker-label2", // your desired CSS class
  //   //       },
  //   //       options: {
  //   //        // icon: 'assets/images/map-icon.png'
  //   //        icon: 'assets/images/map-icon-gray-22x20.png'
  //   //       }
  //   //     }
  //   //   )
  //   // }
  //   const uniqueAuthors = this.markers.reduce((accumulator: any[], current: { label: {  text: any; }; }) => {
  //     if (!accumulator.find((item) => item.label.text === current.label.text)) {
  //       accumulator.push(current);
  //     }
  //     this.uniqueDriver=accumulator;
  //     return accumulator;
  //   }, []);
  //   let bounds;

  markerOverlays: any[] = [];
  // 1️⃣ Input → Firebase Timestamp OR UTC String → Local Date
  parseToLocalDate(dateInput: any): Date | null {
    try {
      // Firebase timestamp?
      if (dateInput?.seconds !== undefined && dateInput?.nanoseconds !== undefined) {
        return new Date(dateInput.seconds * 1000 + dateInput.nanoseconds / 1_000_000);
      }

      // UTC string like: "December 5, 2025 at 4:41:40 AM UTC-5"
      if (typeof dateInput === "string") {
        let cleaned = dateInput.replace(" at ", " ");
        const [mainPart, tz] = cleaned.split(" UTC");
        const timezone = tz ? "UTC" + tz : "";
        const final = `${mainPart} ${timezone}`;
        const parsed = new Date(final);
        return isNaN(parsed.getTime()) ? null : parsed;
      }

      return null;

    } catch {
      return null;
    }
  }
  formatLocalLabel(date: Date): string {
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const strHours = hours.toString().padStart(2, '0');

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthStr = months[date.getMonth()];
    const dayStr = date.getDate().toString();

    return `${strHours}:${minutes} ${ampm}   |   ${monthStr} ${dayStr}`;
  }

  formatForLabel(input: any): string {
    const date = this.parseToLocalDate(input);
    if (!date) return "";
    return this.formatLocalLabel(date);
  }

  computeHeading(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const toRad = (deg: number) => deg * Math.PI / 180;
    const toDeg = (rad: number) => rad * 180 / Math.PI;

    const dLon = toRad(lng2 - lng1);
    const y = Math.sin(dLon) * Math.cos(toRad(lat2));
    const x = Math.cos(toRad(lat1)) * Math.sin(toRad(lat2)) -
      Math.sin(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.cos(dLon);

    const brng = toDeg(Math.atan2(y, x));
    return (brng + 360) % 360;
  }

  addMarker(latitude: any, long: any, id: any, name: string, date?: any, heading?: number, speed?: number) {
    const idStr = String(id);

    // 🔹 DEDUPLICATION LOGIC: Prevent Firestore overriding newer RTDB data
    let timestamp = 0;
    if (date) {
      if (date.seconds !== undefined) {
        timestamp = date.seconds * 1000;
      } else if (typeof date === 'number') {
        timestamp = date;
      } else {
        const parsed = new Date(date).getTime();
        if (!isNaN(parsed)) timestamp = parsed;
      }
    }

    const lastTime = this.driverLastUpdatedTime.get(idStr) || 0;

    // If we have an existing RTDB timestamp, but this new update has NO timestamp (or an older one), reject it.
    if (lastTime > 0) {
      // We add a 2000ms buffer to prevent same-second race conditions
      if (timestamp === 0 || timestamp < lastTime - 2000) {
        console.warn('❌ [addMarker] DEDUP REJECTED for', idStr, '| timestamp:', timestamp, '| lastTime:', lastTime);
        return;
      }
    }

    // Update the last known time only if this new update HAS a valid timestamp
    if (timestamp > 0) {
      this.driverLastUpdatedTime.set(idStr, timestamp);
    }

    const nativeMap = this.map?.googleMap;
    if (!nativeMap) {
      console.warn('Map not ready for custom marker logic. Retrying in 500ms...');
      setTimeout(() => this.addMarker(latitude, long, id, name, date, heading, speed), 500);
      return;
    }

    const driverFromList = this.allDrivers?.find((d: any) => String(d.id) === idStr) || this.listOfDrivers?.find((d: any) => String(d.id) === idStr);
    const isHeadDriver = (driverFromList?.groups && driverFromList.groups[0]?.id === 3);
    const headDriverLabel = isHeadDriver ? "(HD)" : "";
    const driverDisplayName = name;


    // 🔹 SPEED & DEADBAND FILTER: convert m/s to km/h, clamp <5 km/h to 0 (Stopped)
    // GPS drift commonly reports 3-5 km/h for stationary trucks.
    let speedKmh = 0;
    if (speed !== undefined && speed !== null && Number(speed) > 0) {
      speedKmh = Math.round(Number(speed) * 3.6);
    }
    if (speedKmh < 5) {
      speedKmh = 0;
    }

    // 🔹 FAKE GPS & 30-SECOND STATIONARY DEBOUNCE:
    // If coordinates shifted (> 3 meters), mark as moving.
    // If stationary, hold moving status for 30s before transitioning to PARKED.
    const nowMs = Date.now();
    const existingForSpeed = this.markerOverlays.find(o => o.id === idStr || (o.id && o.id.split('-').pop() === idStr.split('-').pop()));
    let coordMoved = false;
    if (existingForSpeed) {
      const dLat = Math.abs(latitude - existingForSpeed.position.lat());
      const dLng = Math.abs(long - existingForSpeed.position.lng());
      if (dLat > 0.00003 || dLng > 0.00003) {
        coordMoved = true;
      }
    }

    if (speedKmh >= 5 || coordMoved) {
      if (speedKmh < 5 && coordMoved) speedKmh = 5;
      this.driverLastMoveTime.set(idStr, nowMs);
      this.driverLastDisplaySpeed.set(idStr, speedKmh);
    } else {
      const lastMove = this.driverLastMoveTime.get(idStr) || 0;
      const lastSpeed = this.driverLastDisplaySpeed.get(idStr) || 0;
      if (lastSpeed >= 5 && (nowMs - lastMove) < 30000) {
        speedKmh = lastSpeed; // Hold moving state during 30s pause
      } else {
        this.driverLastDisplaySpeed.set(idStr, 0);
        speedKmh = 0;
      }
    }

    // Extract initials for the circular initials badge
    const getInitials = (fullName: string) => {
      const parts = fullName.trim().split(/\s+/);
      if (parts.length === 0) return 'D';
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    };
    const initials = getInitials(name || 'Driver');

    // 🔹 SPIDERFIER LOGIC: Handle overlapping markers
    const coordKey = `${latitude.toFixed(6)},${long.toFixed(6)}`;
    let finalLat = latitude;
    let finalLng = long;

    // 1. Check if this is an existing tracked driver (normalized for '14-31' vs '31')
    const existingOverlay = this.markerOverlays.find(o => o.id === idStr || (o.id && o.id.split('-').pop() === idStr.split('-').pop()));

    if (!existingOverlay) {
      // Only apply spiderfier offset to NEW markers (initial load). 
      // Real-time updates should use exact GPS to prevent spiraling off the road when stationary.
      const count = this.coordinateGroups.get(coordKey) || 0;
      if (count > 0) {
        // Apply radial offset: 0.00015 degrees is roughly 15-20 meters
        const angle = (count * 137.5) * (Math.PI / 180); // Fibonacci spiral-ish
        const radius = 0.00015 * Math.sqrt(count);
        finalLat += radius * Math.cos(angle);
        finalLng += radius * Math.sin(angle);
      }
      this.coordinateGroups.set(coordKey, count + 1);
    }

    const cord = new google.maps.LatLng(finalLat, finalLng);
    const formattedDate = date ? this.formatForLabel(date) : '';
    let isOnline = driverFromList?.is_online; // Locate Driver fallback

    // 🔹 Bulletproof 'Online' status for Tracking Modals
    // If the map is opened specifically to track a single driver (Order Details, Active Drivers, Receiving Admin),
    // they are active by definition. We explicitly override isOnline = true for their marker
    // to guarantee the speed pill is always generated on the first render, ignoring any missing API payloads.
    if (!this.locatedriver && this.driverId && String(this.driverId) === idStr) {
      isOnline = true;
    }

    // 1. UPDATE IF EXISTS
    if (existingOverlay) {
      // 🔹 If overlay is hidden (filtered out by tab), silently update position data only.
      if (existingOverlay.overlay.getMap() === null) {
        console.warn('❌ [addMarker] HIDDEN OVERLAY - getMap() is null for', idStr);
        existingOverlay.position = cord;
        const marker = this.markers.find((m: any) => String(m.id) === idStr);
        if (marker) {
          marker.position = { lat: latitude, lng: long };
          marker.speed = speedKmh;
          if (marker.label) marker.label.speed = speedKmh;
        }
        return;
      }

      const oldLat = existingOverlay.position.lat();
      const oldLng = existingOverlay.position.lng();

      const el = existingOverlay.element;
      if (el) {
        el.className = isOnline ? 'driver-marker' : 'driver-marker offline';
        el.style.setProperty('--marker-size', `${this.markerSize}px`);

        // Selective DOM updates to prevent card flickering
        const truckImg = el.querySelector('.truck-icon') as HTMLImageElement;

        // 🔹 Calculate dynamic heading from coordinate deltas if moving, freeze when stopped
        // We IGNORE the raw `heading` from the device because phone compasses in cars are 
        // extremely unreliable (depends on phone mount orientation, metal interference, etc).
        // The direction of travel (route vector) is much more accurate.
        let finalHeading: number;

        const dLat = Math.abs(oldLat - finalLat);
        const dLng = Math.abs(oldLng - finalLng);

        // If coordinates changed (> ~1 meter), update heading immediately
        // (works even if speed reports 0 / PARKED with fake GPS apps)
        if (dLat > 0.00001 || dLng > 0.00001) {
          // Front of truck image (cab, windshield, headlights) is at TOP,
          // so computeHeading points directly in the direction of travel
          finalHeading = this.computeHeading(oldLat, oldLng, finalLat, finalLng);
          this.driverLastHeading.set(idStr, finalHeading);
        } else if (truckImg && truckImg.dataset['lastHeading']) {
          // Stationary: freeze at last known heading
          finalHeading = Number(truckImg.dataset['lastHeading']);
        } else if (this.driverLastHeading.has(idStr)) {
          finalHeading = this.driverLastHeading.get(idStr)!;
        } else {
          finalHeading = 0; // Default North
        }

        if (truckImg) {
          truckImg.className = `truck-icon ${isOnline ? 'online' : 'offline'}`;
          truckImg.src = isOnline ? 'assets/images/top_view_truck_green.png' : 'assets/images/top_view_truck_offline.png';

          truckImg.style.transform = `rotate(${finalHeading}deg)`;
          truckImg.style.transition = 'transform 0.5s ease-in-out';
          truckImg.dataset['lastHeading'] = String(finalHeading);

          const infoCard = el.querySelector('.driver-info-card') as HTMLElement;
          if (infoCard) {
            infoCard.style.transform = `translate(-50%, 36px)`;
          }
        }

        // 🔹 Live update of speed pill
        let speedPill = el.querySelector('.speed-pill') as HTMLElement;

        if (speedPill) {
          if (isOnline) {
            speedPill.style.height = '18px';
            speedPill.style.boxSizing = 'border-box';
            if (speedKmh >= 5) {
              speedPill.className = 'speed-pill moving';
              speedPill.style.background = 'rgba(16, 185, 129, 0.2)';
              speedPill.style.color = '#10b981';
              speedPill.style.borderColor = 'rgba(16, 185, 129, 0.4)';
              speedPill.style.padding = '0 6px';
              speedPill.style.width = 'auto';
              speedPill.style.minWidth = 'auto';
              speedPill.style.fontSize = '10px';
              speedPill.innerHTML = `${speedKmh} km/h`;
            } else {
              speedPill.className = 'speed-pill stopped';
              speedPill.style.background = 'rgba(245, 158, 11, 0.2)';
              speedPill.style.color = '#f59e0b';
              speedPill.style.borderColor = 'rgba(245, 158, 11, 0.4)';
              speedPill.style.padding = '0 6px';
              speedPill.style.width = 'auto';
              speedPill.style.minWidth = 'auto';
              speedPill.innerHTML = `<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="8"/></svg><span style="font-size:8px;font-weight:800;letter-spacing:0.3px;margin-left:4px;">STOPPED</span>`;
            }
          } else {
            speedPill.style.display = 'none';
          }
        }

        const statusIndicator = el.querySelector('.status-indicator') as HTMLElement;
        if (statusIndicator) {
          statusIndicator.style.width = '14px';
          statusIndicator.style.height = '14px';
          statusIndicator.style.minWidth = '14px';
          statusIndicator.style.minHeight = '14px';
          statusIndicator.style.background = isOnline ? 'rgba(16, 185, 129, 0.2)' : 'rgba(148, 163, 184, 0.2)';
          statusIndicator.style.borderColor = isOnline ? 'rgba(16, 185, 129, 0.4)' : 'rgba(148, 163, 184, 0.4)';
          statusIndicator.title = isOnline ? 'Online' : 'Offline';
          const innerDot = statusIndicator.querySelector('span');
          if (innerDot) {
            innerDot.style.width = '6px';
            innerDot.style.height = '6px';
            innerDot.style.background = isOnline ? '#10b981' : '#94a3b8';
            innerDot.style.boxShadow = isOnline ? '0 0 4px rgba(16, 185, 129, 0.8)' : 'none';
          }
        }

        // Fallback for older cached markers before refresh
        const statusPill = el.querySelector('.status-pill');
        if (statusPill) {
          statusPill.className = `status-pill ${isOnline ? 'online' : 'offline'}`;
          statusPill.textContent = isOnline ? 'Online' : 'Offline';
        }

        const timeEl = el.querySelector('.activity-time');
        if (timeEl && formattedDate) {
          if (timeEl.textContent !== formattedDate) {
            timeEl.textContent = formattedDate;
          }
        }
      }


      const oldCord = existingOverlay.position;
      const newCord = cord;

      // Only run the animation if the marker ACTUALLY moved to a new coordinate
      if (oldCord.lat() !== newCord.lat() || oldCord.lng() !== newCord.lng()) {
        console.log('✅ [addMarker] ANIMATING', idStr, 'from', oldCord.lat(), oldCord.lng(), 'to', newCord.lat(), newCord.lng());
        if (existingOverlay.animationFrameId) {
          cancelAnimationFrame(existingOverlay.animationFrameId);
        }

        // 🔹 Check if this is the currently tracked driver.
        // If no driver was chosen in the dropdown, follow the active moving driver.
        const isTracked = this.locateDriverids
          ? (String(this.locateDriverids) === idStr)
          : (!this.currentFollowDriverId || this.currentFollowDriverId === idStr || this.showdriver || this.data?.isDriverDetail || this.data?.orderData);

        if (!this.locateDriverids && isTracked) {
          this.currentFollowDriverId = idStr;
        }

        if (isTracked && this.originalPoints.length > 0) {
          this.trimPolyline(newCord);
        }

        const deltaLat = newCord.lat() - oldCord.lat();
        const deltaLng = newCord.lng() - oldCord.lng();
        const distanceDegrees = Math.sqrt(deltaLat * deltaLat + deltaLng * deltaLng);

        // If distance is large (e.g., > 330 meters / ~0.003 degrees), 
        // it means the tab was asleep or GPS jumped. 
        // Snap immediately instead of animating a "flying truck" across the entire city.
        if (distanceDegrees > 0.003) {
          existingOverlay.position = newCord;
          existingOverlay.overlay.draw();
          if (isTracked && nativeMap && !this.isAutoFollowPaused && !this.isUserZooming) {
            this.center = { lat: newCord.lat(), lng: newCord.lng() };
            nativeMap.setCenter(newCord);
          }
        } else {
          const startTime = performance.now();
          const duration = 4800; // 4.8s matches the 5s database interval almost perfectly

          const animate = (time: number) => {
            let progress = (time - startTime) / duration;
            if (progress > 1) progress = 1;

            // strictly linear speed for continuous driving effect (no braking/accelerating)
            const ease = progress;

            const currentLat = oldCord.lat() + (newCord.lat() - oldCord.lat()) * ease;
            const currentLng = oldCord.lng() + (newCord.lng() - oldCord.lng()) * ease;
            const currentPos = new google.maps.LatLng(currentLat, currentLng);

            existingOverlay.position = currentPos;
            existingOverlay.overlay.draw();

            // 🔹 Safety guard: if truck is about to exit visible viewport bounds, resume auto-follow immediately
            if (nativeMap && nativeMap.getBounds() && !nativeMap.getBounds()!.contains(currentPos)) {
              this.isAutoFollowPaused = false;
            }

            // 🔹 Dynamic tracking check: evaluate on every frame instead of relying on the closure.
            // This prevents the map from violently snapping back if the admin switches drivers 
            // while the 4.8s animation of the previous driver is still running.
            const dynamicallyTracked = this.locateDriverids
              ? (String(this.locateDriverids) === idStr)
              : (!this.currentFollowDriverId || this.currentFollowDriverId === idStr || this.showdriver || this.data?.isDriverDetail || this.data?.orderData);

            // 🔹 Continuous map follow: keep truck on screen unless user is actively zooming or dragging
            if (dynamicallyTracked && nativeMap && !this.isAutoFollowPaused && !this.isUserZooming) {
              nativeMap.setCenter(currentPos);
            }

            if (progress < 1) {
              existingOverlay.animationFrameId = requestAnimationFrame(animate);
            } else {
              existingOverlay.position = newCord;
              existingOverlay.overlay.draw();
              existingOverlay.animationFrameId = undefined;
              if (dynamicallyTracked && nativeMap && !this.isAutoFollowPaused && !this.isUserZooming) {
                this.center = { lat: newCord.lat(), lng: newCord.lng() };
                nativeMap.setCenter(newCord);
              }
            }
          };

          existingOverlay.animationFrameId = requestAnimationFrame(animate);
        }
      } else {
        // If coordinate is identical, skip animation. Just make sure it's drawn.
        console.log('⏸️ [addMarker] SAME COORD skip for', idStr, '| old:', oldCord.lat(), oldCord.lng(), '| new:', newCord.lat(), newCord.lng());
        existingOverlay.position = newCord;
        existingOverlay.overlay.draw();
      }

      const marker = this.markers.find((m: any) => String(m.id) === idStr);
      if (marker) {
        marker.position = { lat: latitude, lng: long };
        marker.speed = speedKmh;
        if (marker.label) marker.label.speed = speedKmh;
        marker.label.dropdownLabel = isOnline ? name : name + ' (Offline)';
        marker.label.text = marker.label.dropdownLabel;
      }
      if (this.uniqueDriver && this.uniqueDriver.length > 0) {
        const uMarker = this.uniqueDriver.find((m: any) => String(m.id) === idStr);
        if (uMarker) {
          uMarker.position = { lat: latitude, lng: long };
        }
      }
      this.applyZIndexHighlight();
      return;
    }

    // 2. CREATE NEW
    const div = document.createElement('div');
    div.className = isOnline ? 'driver-marker' : 'driver-marker offline';
    div.style.cursor = 'pointer';
    div.style.zIndex = '1';
    div.style.position = 'absolute';
    div.style.willChange = 'transform';
    div.style.left = '0px';
    div.style.top = '0px';
    div.style.setProperty('--marker-size', `${this.markerSize}px`);

    // Use component-level persisted heading as fallback for initial render.
    // This covers the case where the page loads and the driver is stopped — the truck will
    // show its last known travel direction rather than defaulting to North (0°).
    const effectiveHeading = this.driverLastHeading.get(idStr) ?? 0;

    // FIXED ANCHOR: Always stay 36px below the center, cleanly below the 60px truck icon
    const cardTransform = `translate(-50%, 36px)`;

    const speedBadgeHtml = isOnline ? `
      <span class="speed-pill ${speedKmh >= 5 ? 'moving' : 'stopped'}" 
            style="font-size: 10px; font-weight: 700; padding: 0 6px; border-radius: 5px; letter-spacing: 0.3px; border: 1px solid ${speedKmh >= 5 ? 'rgba(16, 185, 129, 0.4)' : 'rgba(245, 158, 11, 0.4)'}; background: ${speedKmh >= 5 ? 'rgba(16, 185, 129, 0.2)' : 'rgba(245, 158, 11, 0.2)'}; color: ${speedKmh >= 5 ? '#10b981' : '#f59e0b'}; display: inline-flex; align-items: center; justify-content: center; white-space: nowrap; height: 18px; box-sizing: border-box; flex-shrink: 0;">
        ${speedKmh >= 5 ? `${speedKmh} km/h` : `<svg width="8" height="8" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="8"/></svg><span style="font-size:8px;font-weight:800;letter-spacing:0.3px;margin-left:4px;">STOPPED</span>`}
      </span>
    ` : '';

    div.innerHTML = `
    <div class="driver-label-wrapper" style="position: relative; width: 60px; height: 60px; display: flex; align-items: center; justify-content: center;">
      <div class="marker-icon-wrapper" style="position: relative; z-index: 2;">
        <img src="${isOnline ? 'assets/images/top_view_truck_green.png' : 'assets/images/top_view_truck_offline.png'}" 
             class="truck-icon ${isOnline ? 'online' : 'offline'}" 
             style="width: 60px; height: 60px; object-fit: contain; filter: drop-shadow(0px 3px 6px rgba(0,0,0,0.4)); transform: rotate(${effectiveHeading}deg); transition: transform 0.5s ease-in-out;" 
             data-last-heading="${effectiveHeading}" />
      </div>
      <div class="driver-info-card compact-card" style="position: absolute; left: 50%; top: 50%; margin: 0; z-index: 1; transform: ${cardTransform}; transition: transform 0.5s ease-in-out; display: flex; flex-direction: column; gap: 6px; align-items: stretch; text-align: left; min-width: 130px; max-width: 220px; padding: 7px 10px; box-sizing: border-box;">
        <div style="display: flex; justify-content: space-between; width: 100%; align-items: center; gap: 10px;">
          <div style="display: flex; align-items: center; gap: 6px; min-width: 0; flex: 1; overflow: hidden;">
            <span class="status-indicator" style="display: flex; align-items: center; justify-content: center; width: 14px; height: 14px; min-width: 14px; min-height: 14px; border-radius: 50%; background: ${isOnline ? 'rgba(16, 185, 129, 0.2)' : 'rgba(148, 163, 184, 0.2)'}; border: 1px solid ${isOnline ? 'rgba(16, 185, 129, 0.4)' : 'rgba(148, 163, 184, 0.4)'}; flex-shrink: 0;" title="${isOnline ? 'Online' : 'Offline'}">
              <span style="width: 6px; height: 6px; border-radius: 50%; background: ${isOnline ? '#10b981' : '#94a3b8'}; box-shadow: ${isOnline ? '0 0 4px rgba(16, 185, 129, 0.8)' : 'none'};"></span>
            </span>
            <span class="name-text" style="font-size: 13px; font-weight: 700; line-height: 1.2; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #ffffff; min-width: 0;">
              ${this.escapeHtml(driverDisplayName)}
            </span>
          </div>
          <div style="flex-shrink: 0; display: flex; align-items: center;">
            ${speedBadgeHtml}
          </div>
        </div>
        <div style="display: flex; justify-content: center; width: 100%; align-items: center; gap: 10px;">
          <span class="activity-time" style="font-size: 10px; color: #e2e8f0; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; text-align: center;">${formattedDate ? this.escapeHtml(formattedDate) : 'Pending'}</span>
        </div>
      </div>
    </div>
  `;

    div.addEventListener('click', (ev) => {
      const currentUrl = this.router.url;
      if (currentUrl.includes('admin') && !currentUrl.includes('receiving-admin')) {
        this.handleCustomMarkerClick?.(idStr, { lat: latitude, lng: long }, ev);;
      }
    });

    const overlay = new google.maps.OverlayView();
    overlay.onAdd = function () {
      this.getPanes().overlayMouseTarget.appendChild(div);
    };
    overlay.draw = () => {
      const projection = overlay.getProjection();
      if (!projection) return;
      const currentOverlay = this.markerOverlays.find(o => o.id === idStr || (o.id && o.id.split('-').pop() === idStr.split('-').pop()));
      const currentPos = currentOverlay ? currentOverlay.position : cord;
      const pos = projection.fromLatLngToDivPixel(currentPos);
      if (pos) {
        div.style.left = `${pos.x}px`;
        div.style.top = `${pos.y}px`;
      }
    };
    overlay.onRemove = function () {
      if (div.parentNode) div.parentNode.removeChild(div);
    };

    overlay.setMap(nativeMap);
    this.markerOverlays.push({ id: idStr, overlay, element: div, position: cord });

    const markerObj = {
      id: idStr,
      position: { lat: latitude, lng: long },
      speed: speedKmh,
      label: {
        dropdownLabel: isOnline ? name : name + ' (Offline)',
        text: isOnline ? name : name + ' (Offline)',
        isOnline: isOnline,
        name: name,
        headdriver: headDriverLabel,
        formattedDate: formattedDate,
        speed: speedKmh
      },
      options: {
        icon: isOnline ? 'assets/images/top_view_truck_green.png' : 'assets/images/top_view_truck_offline.png',
        zIndex: 1
      }
    };
    this.markers.push(markerObj);

    // update uniqueDriver
    const driverIds = new Set(this.markers.map((m: any) => String(m.id)));
    this.uniqueDriver = this.listOfDrivers
      .filter((d: any) => driverIds.has(String(d.id)))
      .map((d: any) => this.markers.find((m: any) => String(m.id) === String(d.id)));

    this.applyZIndexHighlight();
  }



  applyZIndexHighlight() {
    const selectedName = localStorage.getItem('selectedDriverLabel');
    const selectedId = this.locateDriverids ? String(this.locateDriverids) : null;
    const trackedModalId = (!this.locatedriver && this.driverId) ? String(this.driverId) : null;

    this.markers.forEach((m: any) => {
      const markerId = String(m.id);
      const markerName = m.label?.dropdownLabel || m.label?.text;

      const isSelected = (selectedId && markerId === selectedId) ||
        (selectedName && markerName?.trim() === selectedName.trim()) ||
        (trackedModalId && markerId === trackedModalId);

      m.options = {
        ...m.options,
        zIndex: isSelected ? 999999 : 1,
        opacity: 1
      };
    });

    this.markerOverlays.forEach(o => {
      const markerId = String(o.id);
      const nameEl = o.element?.querySelector('.name-text');
      const elementName = nameEl?.textContent;

      const isSelected = (selectedId && markerId === selectedId) ||
        (selectedName && elementName?.trim() === selectedName.trim()) ||
        (trackedModalId && markerId === trackedModalId);

      if (isSelected) {
        o.element.style.zIndex = "999999";
        o.element.style.opacity = "1";
        const speedPill = o.element.querySelector('.speed-pill') as HTMLElement;
        if (speedPill) speedPill.style.display = 'inline-flex';
      } else {
        o.element.style.zIndex = "1";
        o.element.style.opacity = "1";
        const speedPill = o.element.querySelector('.speed-pill') as HTMLElement;
        if (speedPill) speedPill.style.display = 'none';
      }
    });

    this.markers = [...this.markers];
  }

  /**
   * 🔹 Instant tab filter: show/hide existing overlays using cached allDrivers data.
   * Zero network calls — purely client-side filtering of data already in memory.
   */
  applyFilterVisually(): void {
    // 1. Rebuild listOfDrivers from cached allDrivers
    if (this.allDrivers && this.allDrivers.length > 0) {
      if (this.filterType === 'online') {
        this.listOfDrivers = this.allDrivers.filter(d => d.is_online === true);
      } else if (this.filterType === 'offline') {
        this.listOfDrivers = this.allDrivers.filter(d => d.is_online === false);
      } else if (this.filterType === 'pending') {
        this.listOfDrivers = this.allDrivers.filter(d => !d.drivertime?.length);
      } else {
        this.listOfDrivers = [...this.allDrivers];
      }
      localStorage.setItem('locatedriversList', JSON.stringify(this.listOfDrivers));
      this.driversUpdated.emit(this.allDrivers);
    }

    // 2. Build a set of driver IDs that match the current filter
    const visibleIds = new Set(this.listOfDrivers.map((d: any) => String(d.id)));
    const nativeMap = this.map?.googleMap;

    // 3. Sync marker properties and show/hide overlays instantly
    this.markerOverlays.forEach(o => {
      // 🔹 Fetch fresh status from allDrivers to prevent stale green/red dots
      const driverData = this.allDrivers?.find((d: any) => String(d.id) === o.id || String(d.driver_id) === o.id);
      const isOnline = driverData?.is_online ?? true;

      if (o.element) {
        // Update truck icon
        const truckImg = o.element.querySelector('.truck-icon') as HTMLImageElement;
        if (truckImg) {
          truckImg.className = `truck-icon ${isOnline ? 'online' : 'offline'}`;
          truckImg.src = isOnline ? 'assets/images/top_view_truck_green.png' : 'assets/images/top_view_truck_offline.png';
        }

        // Update status pill
        const statusPill = o.element.querySelector('.status-pill');
        if (statusPill) {
          statusPill.className = `status-pill ${isOnline ? 'online' : 'offline'}`;
          statusPill.textContent = isOnline ? 'Online' : 'Offline';
        }

        // Update the circular dot indicator
        const statusIndicator = o.element.querySelector('.status-indicator') as HTMLElement;
        if (statusIndicator) {
          statusIndicator.style.background = isOnline ? 'rgba(16, 185, 129, 0.2)' : 'rgba(148, 163, 184, 0.2)';
          statusIndicator.style.borderColor = isOnline ? 'rgba(16, 185, 129, 0.4)' : 'rgba(148, 163, 184, 0.4)';
          statusIndicator.title = isOnline ? 'Online' : 'Offline';
          const innerDot = statusIndicator.querySelector('span');
          if (innerDot) {
            innerDot.style.background = isOnline ? '#10b981' : '#94a3b8';
            innerDot.style.boxShadow = isOnline ? '0 0 4px rgba(16, 185, 129, 0.8)' : 'none';
          }
        }
      }

      // Update the underlying cached marker object so the dropdown gets the correct color
      const cachedMarker = this.markers.find((m: any) => String(m.id) === o.id);
      if (cachedMarker && cachedMarker.label) {
        cachedMarker.label.isOnline = isOnline;
        cachedMarker.label.dropdownLabel = isOnline ? cachedMarker.label.name : cachedMarker.label.name + ' (Offline)';
        cachedMarker.label.text = cachedMarker.label.dropdownLabel;
      }

      // Show/Hide based on filters
      const shouldShow = this.filterType === 'all' || visibleIds.has(o.id);
      if (shouldShow) {
        if (o.overlay.getMap() === null && nativeMap) {
          o.overlay.setMap(nativeMap);
        }
        if (o.element) o.element.style.display = '';
      } else {
        if (o.overlay.getMap() !== null) {
          o.overlay.setMap(null);
        }
        if (o.element) o.element.style.display = 'none';
      }
    });

    // 4. Sync uniqueDriver array
    if (this.filterType === 'all') {
      const driverIds = new Set(this.markers.map((m: any) => String(m.id)));
      this.uniqueDriver = this.listOfDrivers
        .filter((d: any) => driverIds.has(String(d.id)))
        .map((d: any) => this.markers.find((m: any) => String(m.id) === String(d.id)));
    } else {
      this.uniqueDriver = this.markers.filter((m: any) => visibleIds.has(String(m.id)));
    }

    // 5. Re-apply selection highlight
    this.applyZIndexHighlight();
  }

  // basic html escaper
  escapeHtml(str: any) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  handleCustomMarkerClick(id: any, pos: any, ev?: MouseEvent) {
    const m = this.markers.find((x: { id: any; }) => String(x.id) === String(id));
    if (m) {
      // Treat clicking the marker exactly as if it was selected from the dropdown
      this.selectCustomDriver(m);
    }
  }
  // End of helper methods
  //     return markerName === normalizedSelected;
  //   });

  //   if (exists) {
  //     // Assign the exact marker text to show in dropdown
  //     this.selectedDriverLabel = exists.label.text;

  //     // Update in localStorage
  //     localStorage.setItem('selectedDriverLabel', exists.label.text);
  //   } else {
  //     this.selectedDriverLabel = '';
  //     localStorage.removeItem('selectedDriver');
  //   }
  // }



  //       console.log(this.markers,'this.markers')
  //     }

  //     // Instead of reducing from this.markers, preserve order using this.listOfDrivers
  //   //   const driverIds = new Set(this.markers.map((m: { id: any; }) => m.id));
  //   //   this.uniqueDriver = this.listOfDrivers
  //   //     .filter((driver: { id: unknown; }) => driverIds.has(driver.id)) // keep only those shown as markers
  //   //     .map((driver: { id: any; }) => {
  //   //       const marker = this.markers.find((m: { id: any; }) => m.id === driver.id);
  //   //       return marker; // this will be in the same order as listOfDrivers
  //   //     });
  //   // this.selectedDriverLabel = this.selectedDriverLabel;
  //     // Fit bounds as usual
  //     // const bounds = this.data.driverData
  //     //   ? this.getBounds(this.markers)
  //     //   : this.getDefaultBounds(this.markers);
  //     // this.map?.googleMap?.fitBounds(bounds);
  //     // this.map?.googleMap?.setZoom(15);
  //   }
  formatDateForLabel(dateString: string): string {
    if (dateString) {
      const dateObj = this.fixDate(dateString);

      if (!dateObj) return "Invalid date";

      const options: Intl.DateTimeFormatOptions = {
        weekday: 'short',
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      };

      const formatted = dateObj
        .toLocaleString('en-US', options)
        .replace(',', '');
      return formatted;
    }
    return ''
  }

  fixDate(dateString: string): Date | null {
    try {
      let cleaned = dateString?.replace(" at ", " ");
      const [mainPart, tzPart] = cleaned.split(" UTC");
      const timezone = tzPart ? "UTC" + tzPart : "";
      const finalString = `${mainPart} ${timezone}`;
      const parsed = new Date(finalString);

      if (isNaN(parsed.getTime())) {
        return null;
      }
      return parsed;

    } catch (err) {
      return null;
    }
  }

  markerRefs: Map<any, google.maps.Marker> = new Map();
  jitterIntervals: Map<any, any> = new Map(); // for optional idle jitter

  // addMarkers(latitude:any, long:any, id?:any,name?:string) {
  //   let cord = {lat: Number(latitude), lng: Number(long)}
  //   const existingMarker = this.markers.find((marker: { id: any; }) => marker.id === id);
  //   if (existingMarker) {
  //     // Update existing marker's position
  //     existingMarker.position = cord;
  // } 
  // else{
  //   if(cord){
  //     this.markers.push(
  //       {
  //         id: id,
  //         position : cord,
  //         label: {
  //           color: '#0eb002',
  //           text: name?name.toString() : '',
  //           className: 'marker-label1',
  //           fontWeight: 'bold',
  //           labelClass: "marker-label1", 
  //           style: {
  //             backgroundColor: 'none', // Set background to none
  //           }
  //         },
  //         options: {
  //           icon: 'assets/images/map-icon.png',
  //           zIndex: 9999 ,
  //           // Set the desired z-index value
  //         }
  //       }
  //     )
  //   }
  // }
  //   const uniqueAuthors = this.markers.reduce((accumulator: any[], current: { label: {  text: any; }; }) => {
  //     if (!accumulator.find((item) => item.label.text === current.label.text)) {
  //       accumulator.push(current);
  //     }
  //     this.uniqueDriver=accumulator;
  //     return accumulator;
  //   }, []);
  //   let bounds;
  //   if(this.data.orderData){
  //     bounds = this.getBounds(this.markers);
  //   } else{
  //     bounds = this.getDefaultBounds(this.markers);    }

  //   this.map?.googleMap?.fitBounds(bounds);
  //   this.map?.googleMap?.setZoom(15)


  getDriverFullName(driver: any): string {
    if (!driver) return '';
    return `${driver.first_name || ''} ${driver.last_name || ''}`.trim();
  }

  addMarkers(latitude: any, long: any, id?: any, name?: string, date?: any, heading?: number, speed?: number) {
    this.coordinateGroups.clear(); // Reset collision tracker
    // Unify with premium singular addMarker for luxury look everywhere
    this.addMarker(latitude, long, id, name || "Driver", date, heading, speed);

    // Maintain centering logic for directions ONLY if it's not a full order route (to avoid ruining bounds)
    const cord = new google.maps.LatLng(Number(latitude), Number(long));
    if (this.map?.googleMap && !this.data?.orderData) {
      this.map.googleMap.setCenter(cord);
      this.map.googleMap.setZoom(15);
    }
  }

  setDestinationMarker(position: any) {
    const nativeMap = this.map?.googleMap;
    if (!nativeMap || !position) return;

    const cord = new google.maps.LatLng(position.lat, position.lng);
    const orderType = (this.data?.orderData?.order_type || this.selectedDriverOrderData?.order_type || 'delivery').toLowerCase();

    let iconColor = '#059669'; // default delivery green
    let iconLetter = 'D';

    if (orderType === 'pickup') {
      iconColor = '#db2777'; // pink/red
      iconLetter = 'P';
    } else if (orderType === 'warehouse') {
      iconColor = '#1e40af'; // blue
      iconLetter = 'W';
    }

    const svgIcon = {
      url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="36" height="48">
          <path fill="${iconColor}" d="M172.3 507.2C166.9 513.7 156.9 513.7 151.4 507.2C118.8 468.4 0 321.4 0 192C0 86 85.9 0 192 0S384 86 384 192c0 129.4-118.8 276.4-151.4 315.2c-5.5 6.5-15.5 6.5-20.9 0L172.3 507.2z"/>
          <text x="192" y="240" fill="#ffffff" font-size="140" font-weight="900" font-family="Arial, sans-serif" text-anchor="middle" dominant-baseline="middle">${iconLetter}</text>
        </svg>
      `),
      scaledSize: new google.maps.Size(36, 48),
      anchor: new google.maps.Point(18, 48)
    };

    if (this.destinationMarker) {
      this.destinationMarker.setPosition(cord);
      this.destinationMarker.setIcon(svgIcon);
      this.destinationMarker.setZIndex(0);
    } else {
      this.destinationMarker = new google.maps.Marker({
        position: cord,
        map: nativeMap,
        title: orderType.charAt(0).toUpperCase() + orderType.slice(1) + ' Location',
        icon: svgIcon,
        zIndex: 0
      });
    }
  }
  animateMarkerMove(marker: google.maps.Marker, newPosition: google.maps.LatLng) {
    const duration = 600; // total time to move in ms
    const frames = 40;
    const interval = duration / frames;

    const startPosition = marker.getPosition();
    if (!startPosition) return;

    let frame = 0;
    const deltaLat = (newPosition.lat() - startPosition.lat()) / frames;
    const deltaLng = (newPosition.lng() - startPosition.lng()) / frames;

    const move = () => {
      frame++;
      const lat = startPosition.lat() + deltaLat * frame;
      const lng = startPosition.lng() + deltaLng * frame;
      marker.setPosition(new google.maps.LatLng(lat, lng));
      if (frame < frames) {
        requestAnimationFrame(move);
      }
    };

    requestAnimationFrame(move);
  }
  startIdleJitter(id: any, marker: google.maps.Marker) {
    if (this.jitterIntervals.has(id)) return; // Prevent multiple intervals

    const interval = setInterval(() => {
      const pos = marker.getPosition();
      if (pos) {
        const jitterLat = pos.lat() + (Math.random() - 0.5) * 0.00002;
        const jitterLng = pos.lng() + (Math.random() - 0.5) * 0.00002;
        marker.setPosition(new google.maps.LatLng(jitterLat, jitterLng));
      }
    }, 1000);

    this.jitterIntervals.set(id, interval);
  }

  animateOverlayMove(overlayObj: any, newPosition: google.maps.LatLng) {
    // 4-second animation perfectly matches the 5-second RTDB interval, 
    // creating a continuous, smooth driving effect instead of stop-and-start.
    const duration = 4000;
    let startTimestamp: number | null = null;
    const startPosition = overlayObj.position;

    // Cancel any existing animation on this truck to prevent flickering/repeating
    if (overlayObj.animationId) {
      cancelAnimationFrame(overlayObj.animationId);
      overlayObj.animationId = null;
    }

    if (!startPosition) {
      overlayObj.position = newPosition;
      overlayObj.overlay.draw();
      return;
    }

    const deltaLat = newPosition.lat() - startPosition.lat();
    const deltaLng = newPosition.lng() - startPosition.lng();

    // If distance is large (e.g., > 330 meters / ~0.003 degrees), 
    // it means the tab was asleep or GPS jumped. 
    // Snap immediately instead of animating a "flying truck".
    // We use 0.003 because at 70mph, a 5-second update interval covers ~150 meters.
    const distanceDegrees = Math.sqrt(deltaLat * deltaLat + deltaLng * deltaLng);
    if (distanceDegrees > 0.003) {
      overlayObj.position = newPosition;
      overlayObj.overlay.draw();
      return;
    }

    const move = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);

      const lat = startPosition.lat() + deltaLat * progress;
      const lng = startPosition.lng() + deltaLng * progress;

      overlayObj.position = new google.maps.LatLng(lat, lng);
      overlayObj.overlay.draw(); // trigger redraw to slide the div

      if (progress < 1) {
        overlayObj.animationId = requestAnimationFrame(move);
      } else {
        overlayObj.position = newPosition; // ensure exact final position
        overlayObj.overlay.draw();
        overlayObj.animationId = null;
      }
    };

    overlayObj.animationId = requestAnimationFrame(move);
  }

  addMarkersss(latitude: any, long: any) {
    this.coordinateGroups.clear(); // Reset collision tracker
    let cord = { lat: Number(latitude), lng: Number(long) }

    if (cord) {
      this.markers.push(
        {
          position: cord,
          label: {
            color: '#0eb002',
            className: 'marker-label1',
            fontWeight: 'bold',
            labelClass: "marker-label1",
            style: {
              backgroundColor: 'none', // Set background to none
            }
          },
          options: {
            icon: 'assets/images/top_view_truck_green.png',
            zIndex: 9999,
            // Set the desired z-index value
          }
        }
      )
    }
    const uniqueAuthors = this.markers.reduce((accumulator: any[], current: { label: { text: any; }; }) => {
      if (!accumulator.find((item) => item.label.text === current.label.text)) {
        accumulator.push(current);
      }
      this.uniqueDriver = accumulator;
      return accumulator;
    }, []);
    let bounds;
    if (this.data.orderData) {
      bounds = this.getBounds(this.markers);
    } else {
      bounds = this.getDefaultBounds(this.markers);
    }

    this.map?.googleMap?.fitBounds(bounds);
    this.map?.googleMap?.setZoom(15)


  }
  filteredData: any;
  originalValue: any
  locateDriverids: any;
  // onDriverSelected(event: any) {
  //    this.originalValue = event.target.value;
  //    localStorage.setItem('selectedDriverLabel',this.originalValue );
  //    this.selectedDriverLabel = this.originalValue; // update ngModel
  //   this.selectedDriver = this.originalValue.replace(/\s+/g, ' ').trim().toLowerCase();

  //   if (typeof event.target.value === 'string') {
  //     this.selectedDriver = event.target.value.trim().toLowerCase().replace(/\s+/g, '');
  //     this.filteredData = this.markers.filter((marker: { label: any }) =>
  //       marker.label.dropdownLabel.trim().toLowerCase().replace(/\s+/g, '') === this.selectedDriver
  //     );

  //     // Reset zIndex for all markers
  //     this.markers.forEach((marker: any) => {
  //       marker.options = {
  //         ...marker.options,
  //         zIndex: 1 // default
  //       };
  //     });
  //     // Set the center and zIndex of the selected marker
  //     if (this.selectedDriver && this.filteredData.length > 0) {
  //       const selectedMarker = this.filteredData[0];
  //       this.locateDriverids = this.filteredData[0].id;
  //       this.map?.googleMap?.setCenter(selectedMarker.position);
  //       this.map?.googleMap?.setZoom(15);

  //       // Bring selected marker to front
  //       selectedMarker.options = {
  //         ...selectedMarker.options,
  //         zIndex: 999
  //       };
  //     }

  //     this.myFunction(this.title, 'onDriverSelected');
  //   }
  // }
  onDriverSelected(event: any) {
    this.isAutoFollowPaused = false;
    this.isManualSelection = true;
    const value = event.target.value;
    this.originalValue = value;
    localStorage.setItem('selectedDriverLabel', this.originalValue);
    this.selectedDriverLabel = this.originalValue; // update ngModel

    if (typeof value === 'string') {
      // Normalize driver name for comparison
      const normalizedDriver = value.trim().toLowerCase().replace(/\s+/g, '');
      this.selectedDriver = normalizedDriver;

      // Filter markers for the selected driver
      this.filteredData = this.markers.filter((marker: any) =>
        marker.label.dropdownLabel.trim().toLowerCase().replace(/\s+/g, '') === normalizedDriver
      );

      // Reset zIndex for all marker overlays
      this.markerOverlays.forEach((overlayObj: any) => {
        if (overlayObj.element) {
          overlayObj.element.style.zIndex = '1'; // default
        }
      });

      // Bring selected marker to front and center map
      if (this.filteredData.length > 0) {
        const selectedMarker = this.filteredData[0];
        this.locateDriverids = selectedMarker.id;
        this.currentFollowDriverId = String(selectedMarker.id);

        // Find the corresponding overlay
        const selectedOverlay = this.markerOverlays.find((o: any) => String(o.id) === String(selectedMarker.id));
        if (selectedOverlay && selectedOverlay.element) {
          selectedOverlay.element.style.zIndex = '999'; // bring to top
        }

        // Center and zoom map
        this.center = selectedMarker.position;
        this.map?.googleMap?.setCenter(this.center);
        this.map?.googleMap?.setZoom(16); // Zoomed in more to scatter clusters

        // 🔹 Start RTDB tracking for selected driver — ONLY for online drivers
        if (this.locateDriverids && !this.isOfflineDriverSelected) {
          // Clear stale individual socket data from previous selection
          this.selectedDriverDetail = null;

          this.locateDriverService.startActiveWatcher(String(this.locateDriverids), this.getDriverName(this.locateDriverids) || 'Unknown Driver');
          this.locateDriverWsService.connectIndividualSocket(String(this.locateDriverids));

          // Cold-start: seed bottom sheet from allDrivers until individual socket streams in.
          // Once the individual socket fires, selectedDriverDetail takes over completely.
          const driverListInfo = this.allDrivers?.find((d: any) => String(d.id) === String(this.locateDriverids));
          if (driverListInfo?.running_order) {
            if (driverListInfo.running_order.order_status?.toLowerCase().trim() === 'warehouse') {
              driverListInfo.running_order.order_type = 'warehouse';
            }
            if (driverListInfo.running_order.order_type) {
              driverListInfo.running_order.order_type = driverListInfo.running_order.order_type.trim();
            }
            this.selectedDriverOrderData = driverListInfo.running_order;
            this.currentDrawnOrderId = driverListInfo.running_order.order_id;
            this.drawDriverRouteFromBackend();
          } else {
            this.selectedDriverOrderData = null;
            this.currentDrawnOrderId = null;
            this.clearBackendRoute();
          }
        } else if (this.isOfflineDriverSelected) {
          // Offline driver: clear any stale tracking state but keep map centered
          this.selectedDriverOrderData = null;
          this.currentDrawnOrderId = null;
          this.selectedDriverDetail = null;
          this.clearBackendRoute();
        }
      }

      this.applyZIndexHighlight();
      this.myFunction(this.title, 'onDriverSelected');
    }
  }


  // ---------- getDriverLocationsFromFirebase ----------
  async getDriverLocationsFromFirebase1(): Promise<void> {
    try {
      const res: any = await this.locateDriverService.getDriversInfo();
      this.driverLocations = res;

      if (this.driverLocations && this.driverLocations.length > 0) {
        // Add driver names
        for (let index = 0; index < this.driverLocations.length; index++) {
          const name = this.getDriverName(this.driverLocations[index].driver_id);
          this.driverLocations[index]['name'] = name;
        }

        // Add markers sequentially
        this.coordinateGroups.clear(); // Reset collision tracker before update
        for (const element of this.driverLocations) {
          if (element.location && element.name?.toString().length) {
            // 🔹 FILTER LOGIC: Skip drivers that don't match the current filterType
            const driverId = String(element.driver_id);
            const driverFromList = this.listOfDrivers?.find((d: any) => String(d.id) === driverId);

            if (this.filterType === 'all' || driverFromList) {
              await this.addMarker(
                element.location.latitude,
                element.location.longitude,
                element.driver_id,
                element.name,
                element.location.updatedTime,
                element.location.heading,
                element.location.speed
              );
            }
          }
        }
      }
    } catch (error) {
      console.error('Error fetching driver locations:', error);
    }
  }
  async getDriverLocationsByCompanies(): Promise<void> {
    try {
      // 🔹 1. LocalStorage se payload uthao
      const storedPayload = localStorage.getItem('companyDriverPayload');
      let companyDriverPayload = storedPayload ? JSON.parse(storedPayload) : [];

      // 🔹 2. Transform nested → flat
      const formattedPayload = companyDriverPayload.map((company: any) => ({
        company_id: company.company_id,
        driver_ids: company.driver_ids.map((d: any) => d[0]) // 👈 "14-31"
      }));

      // 🔹 3. Firebase se filtered drivers lao
      const res: any = await this.locateDriverService.getDriversInfoByCompanies(formattedPayload);
      this.driverLocations = res;

      if (this.driverLocations && this.driverLocations.length > 0) {

        // 🔹 4. Driver names attach karo
        this.coordinateGroups.clear(); // Reset collision tracker before update
        for (let index = 0; index < this.driverLocations.length; index++) {
          const fullId = this.driverLocations[index].driver_id; // "14-31"
          const driverId = fullId.split('-')[1]; // "31"
          const name = this.getDriverName(driverId);
          this.driverLocations[index]['name'] = name;
        }

        // 🔹 5. Markers clear (important) only on hard refresh
        // Handled in onDriverSelectedLocal now, so we don't strictly need to clear here if we want smooth updates.
        // But to be safe if this is called directly, we won't clear here. We'll let addMarker handle updates.

        // 🔹 6. Markers add karo (same logic)
        for (const element of this.driverLocations) {
          if (element.location && element.name?.toString().length) {

            const driverId = String(element.driver_id).split('-')[1];
            const driverFromList = this.listOfDrivers?.find(
              (d: any) => String(d.id) === driverId
            );

            if (this.filterType === 'all' || driverFromList) {
              await this.addMarker(
                element.location.latitude,
                element.location.longitude,
                String(element.driver_id).split('-')[1],
                element.name,
                element.location.updatedTime,
                element.location.heading,
                element.location.speed
              );
            }
          }
        }
      }

    } catch (error) {
      console.error('Error fetching driver locations:', error);
    }
  }
  selectedDriverLabel: string = '';
  isDropdownOpen: boolean = false;
  isPanelCollapsed: boolean = false;
  hideBottomSheet: boolean = false;

  togglePanel() {
    this.isPanelCollapsed = !this.isPanelCollapsed;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Bottom-sheet getters — data priority:
  //   1. selectedDriverDetail  → individual socket (most current, single driver)
  //   2. allDrivers            → main socket (cold-start fallback only)
  //   3. this.data.orderData   → dialog data (isShowDirections mode)
  // ─────────────────────────────────────────────────────────────────────────

  get isSelectedDriverOnline(): boolean {
    if (this.data?.isDriverDetail && this.data?.driverData?.is_online !== undefined) {
      return this.data.driverData.is_online;
    }
    if (this.data?.isShowDirections && this.data?.orderData?.current_driver?.id) {
      return true; // Active orders implies online
    }
    // ✅ Individual socket is source of truth
    if (this.selectedDriverDetail?.is_online !== undefined) {
      return this.selectedDriverDetail.is_online;
    }
    // Fallback: cold-start from allDrivers before individual socket fires
    if (this.locateDriverids) {
      const driver = this.allDrivers?.find((d: any) => String(d.id) === String(this.locateDriverids));
      if (driver) return driver.is_online;
    }
    return false;
  }

  get selectedDriverProfileImage(): string | null {
    if (this.data?.isDriverDetail && this.data?.driverData?.profile_image) {
      return this.data.driverData.profile_image;
    }
    if (this.data?.isShowDirections && this.data?.orderData?.current_driver?.profile_image) {
      return this.data.orderData.current_driver.profile_image;
    }
    // ✅ Individual socket is source of truth
    if (this.selectedDriverDetail?.profile_image) {
      return this.selectedDriverDetail.profile_image;
    }
    // Fallback: cold-start from allDrivers before individual socket fires
    if (this.locateDriverids) {
      const driver = this.allDrivers?.find((d: any) => String(d.id) === String(this.locateDriverids));
      if (driver?.profile_image) return driver.profile_image;
    }
    return null;
  }

  get isSelectedDriverHD(): boolean {
    if (this.data?.isShowDirections && this.data?.orderData?.current_driver) {
      return !!(this.data.orderData.current_driver.groups && this.data.orderData.current_driver.groups[0]?.id === 3);
    }
    // ✅ Individual socket is source of truth
    if (this.selectedDriverDetail?.groups) {
      return !!(this.selectedDriverDetail.groups[0]?.id === 3);
    }
    // Fallback: cold-start from allDrivers before individual socket fires
    if (this.locateDriverids) {
      const driver = this.allDrivers?.find((d: any) => String(d.id) === String(this.locateDriverids));
      return !!(driver?.groups && driver.groups[0]?.id === 3);
    }
    return false;
  }

  get selectedDriverOrderStatus(): string {
    if (this.data?.isShowDirections && this.data?.orderData?.order_status) {
      return this.data.orderData.order_status;
    }
    // ✅ Individual socket is source of truth — reads from selectedDriverOrderData
    // which is set directly from the individual socket's running_order field
    if (this.selectedDriverOrderData?.order_status) {
      return this.selectedDriverOrderData.order_status;
    }
    // Fallback: cold-start from allDrivers before individual socket fires
    if (this.locateDriverids) {
      const driver = this.allDrivers?.find((d: any) => String(d.id) === String(this.locateDriverids));
      if (driver?.running_order?.order_status) return driver.running_order.order_status;
    }
    return '';
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isDropdownOpen) return;
    const wrapper = this.elRef.nativeElement.querySelector('.map-dropdown-wrapper');
    if (wrapper && !wrapper.contains(event.target as Node)) {
      this.isDropdownOpen = false;
    }
  }

  selectCustomDriver(marker: any) {
    if (this.filterType === 'offline' || marker.is_online === false) {
      // Allow selection (map centering + highlight) but suppress tracking/bottom sheet
      this.isOfflineDriverSelected = true;
    } else {
      this.isOfflineDriverSelected = false;
    }

    if (this.dragResumeTimeout) clearTimeout(this.dragResumeTimeout);
    this.currentFollowDriverId = String(marker.id);
    this.isAutoFollowPaused = false;
    this.isUserZooming = false;
    this.selectedDriverLabel = marker.label.dropdownLabel;
    this.locateDriverids = marker.id;
    localStorage.setItem('selectedDriverId', String(marker.id));
    this.onDriverSelected({ target: { value: marker.label.dropdownLabel } });
    this.isDropdownOpen = false;
  }

  clearDriverSelection() {
    if (this.dragResumeTimeout) clearTimeout(this.dragResumeTimeout);
    this.currentFollowDriverId = null;
    this.isAutoFollowPaused = false;
    this.isUserZooming = false;
    this.selectedDriverLabel = '';
    this.selectedDriver = '';
    this.locateDriverids = null;
    localStorage.removeItem('selectedDriverLabel');
    localStorage.removeItem('selectedDriverId');
    this.isDropdownOpen = false;

    // Stop tracking the driver — clear both individual-socket-owned variables
    this.locateDriverService.stopActiveWatcher();
    this.locateDriverWsService.disconnectIndividualSocket();
    this.selectedDriverOrderData = null;
    this.selectedDriverDetail = null; // ← clear individual socket data
    this.clearBackendRoute();

    // Fit bounds to show all markers again
    if (this.map?.googleMap) {
      let bounds;
      if (this.data?.orderData) {
        bounds = this.getBounds(this.markers);
      } else {
        bounds = this.getDefaultBounds(this.markers);
      }
      this.map.googleMap.fitBounds(bounds);

      // Ensure zoom is not too tight
      setTimeout(() => {
        const currentZoom = this.map?.googleMap?.getZoom() || 0;
        if (currentZoom > 15) {
          this.map?.googleMap?.setZoom(15);
        }
      }, 100);
    }

    // Reset visual states (z-index, opacity, speed pill)
    this.applyZIndexHighlight();
  }

  async onDriverSelected1(showSpinner: boolean = true) {
    this.isManualSelection = false;
    if (showSpinner) {
      this.loadingMarkers = true;
    }

    try {
      // ✅ Always fetch fresh driver list so online/offline statuses are 100% up to date
      const data: any = await firstValueFrom(this.driverservice.getDriverLocations());
      if (data && data.result && data.result.results) {
        this.allDrivers = data.result.results;

        // 🔹 Center map on warehouse location from API on initial load (eliminates world-map flash)
        if (showSpinner && data.result.warehouse_lat && data.result.warehouse_lng) {
          this.center = { lat: parseFloat(data.result.warehouse_lat), lng: parseFloat(data.result.warehouse_lng) };
          this.map?.googleMap?.setCenter(this.center);
          this.map?.googleMap?.setZoom(10); // Wider zoom level to 9 as requested
        }
      }

      // Apply filtering to the latest available data
      if (this.allDrivers) {
        if (this.filterType === 'online') {
          this.listOfDrivers = this.allDrivers.filter(d => d.is_online === true);
        } else if (this.filterType === 'offline') {
          this.listOfDrivers = this.allDrivers.filter(d => d.is_online === false);
        } else if (this.filterType === 'pending') {
          this.listOfDrivers = this.allDrivers.filter(d => !d.drivertime?.length);
        } else {
          this.listOfDrivers = this.allDrivers;
        }
        this.driversUpdated.emit(this.allDrivers);
        localStorage.setItem("locatedriversList", JSON.stringify(this.listOfDrivers));
      }

      // Refresh markers only on hard refresh
      if (showSpinner) {
        this.markers = [];
        this.uniqueDriver = [];
        this.markerOverlays.forEach(m => m.overlay.setMap(null));
        this.markerOverlays = [];
        this.coordinateGroups.clear();
      }

      await this.getDriverLocationsFromFirebase1();

      // 🔹 Background cleanup: hide overlays for drivers whose status changed since the instant filter
      if (!showSpinner) {
        this.applyFilterVisually();
      }

      // ✅ Do not auto-select on initial load. Let user manually select from dropdown.
      if (this.uniqueDriver && this.uniqueDriver.length > 0) {
        const savedDriverId = this.locateDriverids || localStorage.getItem('selectedDriverId');

        // Only proceed if there's an explicitly saved driver ID (from a recent manual selection)
        if (savedDriverId) {
          const previousLabel = localStorage.getItem('selectedDriverLabel');
          const cleanPreviousName = previousLabel ? previousLabel.replace(/\s*\(Offline\)\s*/i, '').replace(/^\s*\(HD\)\s*/i, '').trim().toLowerCase() : '';

          const selectedMarker = this.uniqueDriver.find((m: any) => {
            if (savedDriverId && String(m.id) === String(savedDriverId)) return true;
            if (m.label?.dropdownLabel === previousLabel) return true;
            const cleanMarkerName = (m.label?.name || m.label?.text || '').replace(/\s*\(Offline\)\s*/i, '').replace(/^\s*\(HD\)\s*/i, '').trim().toLowerCase();
            return cleanPreviousName && cleanMarkerName === cleanPreviousName;
          });

          if (selectedMarker) {
            // Update dropdown and component state
            this.selectedDriverLabel = selectedMarker.label.dropdownLabel;
            localStorage.setItem('selectedDriverLabel', this.selectedDriverLabel);
            localStorage.setItem('selectedDriverId', String(selectedMarker.id));
            this.locateDriverids = selectedMarker.id;

            // 🔹 Start RTDB tracking + individual socket for selected driver
            if (this.locateDriverids) {
              // Clear stale individual socket data from any previous selection
              this.selectedDriverDetail = null;

              this.locateDriverService.startActiveWatcher(String(this.locateDriverids), this.getDriverName(this.locateDriverids) || 'Unknown Driver');

              // ✅ Connect individual socket — this drives the bottom sheet in real time.
              // Without this, the bottom sheet stays frozen on the initial API snapshot
              // because no live data ever arrives for the selected driver.
              this.locateDriverWsService.connectIndividualSocket(String(this.locateDriverids));

              // Cold-start: seed bottom sheet from allDrivers until individual socket fires
              const driverListInfo = this.allDrivers?.find((d: any) => String(d.id) === String(this.locateDriverids));
              if (driverListInfo?.running_order) {
                if (driverListInfo.running_order.order_status?.toLowerCase().trim() === 'warehouse') {
                  driverListInfo.running_order.order_type = 'warehouse';
                }
                if (driverListInfo.running_order.order_type) {
                  driverListInfo.running_order.order_type = driverListInfo.running_order.order_type.trim();
                }
                this.selectedDriverOrderData = driverListInfo.running_order;
                this.currentDrawnOrderId = driverListInfo.running_order.order_id;
                this.drawDriverRouteFromBackend();
              } else {
                this.selectedDriverOrderData = null;
                this.currentDrawnOrderId = null;
                this.clearBackendRoute();
              }
            }

            // Center map on explicit initial load / user selection, or pan smoothly on real-time update
            if (showSpinner) {
              this.center = selectedMarker.position;
              this.map?.googleMap?.setCenter(this.center);
              this.map?.googleMap?.setZoom(16); // Start with high zoom to scatter clustered dots
            } else {
              // Real-time Firebase update: smoothly pan to follow the tracked driver if not paused
              const trackedId = String(this.locateDriverids);
              const trackedMarker = this.uniqueDriver.find((m: any) => String(m.id) === trackedId) || selectedMarker;
              if (trackedMarker?.position && !this.isAutoFollowPaused) {
                this.center = trackedMarker.position;
                this.map?.googleMap?.panTo(this.center);
              }
            }

            this.applyZIndexHighlight();
            console.log('Automatically re-selected driver:', this.selectedDriverLabel);
          }
        } else {
          // Default bounds if no driver is explicitly selected
          if (showSpinner) {
            // We previously set zoom to 9 and centered on the warehouse.
            // Do NOT use fitBounds here, as it overrides our fixed zoom level
            // if all trucks are close together.
            this.map?.googleMap?.setZoom(10);
          }
        }
      }

      this.myFunction(this.title, 'onDriverSelected1');

    } catch (error) {
      console.error('Error in onDriverSelected1:', error);
    } finally {
      this.loadingMarkers = false;
    }
  }
  async onDriverSelectedLocal(showSpinner: boolean = true) {
    this.isManualSelection = false;

    if (showSpinner) {
      this.loadingMarkers = true;
    }

    try {
      // 🔹 1. LocalStorage se company payload uthao
      const storedPayload = localStorage.getItem('companyDriverPayload');
      const companyDriverPayload = storedPayload ? JSON.parse(storedPayload) : [];

      // 🔹 2. Flatten drivers (IMPORTANT FIX)
      this.allDrivers = [];

      companyDriverPayload.forEach((company: any) => {
        company.driver_ids.forEach((d: any) => {
          if (d[1]?.driver_data) {
            this.allDrivers.push({
              ...d[1].driver_data,
              driver_id: d[0] // "14-31"
            });
          }
        });
      });

      // 🔹 3. Filter apply karo
      if (this.allDrivers.length > 0) {
        if (this.filterType === 'online') {
          this.listOfDrivers = this.allDrivers.filter(d => d.is_online === true);
        }
        else if (this.filterType === 'offline') {
          this.listOfDrivers = this.allDrivers.filter(d => d.is_online === false);
        }
        else if (this.filterType === 'pending') {
          this.listOfDrivers = this.allDrivers.filter(
            d => !d.drivertime?.length
          );
        }
        else {
          this.listOfDrivers = this.allDrivers;
        }

        // 🔹 Emit + store
        this.driversUpdated.emit(this.allDrivers);
        localStorage.setItem("locatedriversList", JSON.stringify(this.listOfDrivers));
      }

      // 🔹 4. Markers reset only on hard refresh
      if (showSpinner) {
        this.markers = [];
        this.uniqueDriver = [];

        this.markerOverlays.forEach(m => {
          if (m.overlay) m.overlay.setMap(null);
        });
        this.markerOverlays = [];
        this.coordinateGroups.clear();
      }

      // 🔹 5. Firebase se locations fetch (company-based)
      await this.getDriverLocationsByCompanies();

      // ✅ Do not auto-select on initial load. Let user manually select from dropdown.
      if (this.uniqueDriver && this.uniqueDriver.length > 0) {
        const savedDriverId = this.locateDriverids || localStorage.getItem('selectedDriverId');

        // Only proceed if there's an explicitly saved driver ID (from a recent manual selection)
        if (savedDriverId) {
          const previousLabel = localStorage.getItem('selectedDriverLabel');
          const cleanPreviousName = previousLabel ? previousLabel.replace(/\s*\(Offline\)\s*/i, '').replace(/^\s*\(HD\)\s*/i, '').trim().toLowerCase() : '';

          const selectedMarker = this.uniqueDriver.find((m: any) => {
            if (savedDriverId && String(m.id) === String(savedDriverId)) return true;
            if (m.label?.dropdownLabel === previousLabel) return true;
            const cleanMarkerName = (m.label?.name || m.label?.text || '').replace(/\s*\(Offline\)\s*/i, '').replace(/^\s*\(HD\)\s*/i, '').trim().toLowerCase();
            return cleanPreviousName && cleanMarkerName === cleanPreviousName;
          });

          if (selectedMarker) {
            this.selectedDriverLabel = selectedMarker.label?.dropdownLabel;
            localStorage.setItem('selectedDriverLabel', this.selectedDriverLabel);
            localStorage.setItem('selectedDriverId', String(selectedMarker.id));
            this.locateDriverids = selectedMarker.id;

            // 🔹 Start RTDB tracking for selected driver
            if (this.locateDriverids) {
              this.locateDriverService.startActiveWatcher(String(this.locateDriverids), this.getDriverName(this.locateDriverids) || 'Unknown Driver');
            }

            // 🔹 Map center on explicit initial load / user selection, or pan smoothly on real-time update
            if (showSpinner) {
              this.center = selectedMarker.position;
              this.map?.googleMap?.setCenter(this.center);
              this.map?.googleMap?.setZoom(16);
            } else {
              // Real-time Firebase update: smoothly pan to follow the tracked driver if not paused
              const trackedId = String(this.locateDriverids);
              const trackedMarker = this.uniqueDriver.find((m: any) => String(m.id) === trackedId) || selectedMarker;
              if (trackedMarker?.position && !this.isAutoFollowPaused) {
                this.center = trackedMarker.position;
                this.map?.googleMap?.panTo(this.center);
              }
            }

            this.applyZIndexHighlight();
            console.log('Automatically re-selected driver (Local):', this.selectedDriverLabel);
          }
        } else {
          // Default bounds if no driver is explicitly selected
          if (showSpinner) {
            // Preserve the wide zoom level of 9 instead of fitting bounds tightly.
            this.map?.googleMap?.setZoom(10);
          }
        }
      }

      // 🔹 7. Extra function
      this.myFunction(this.title, 'onDriverSelectedLocal');

    } catch (error) {
      console.error('Error in onDriverSelectedLocal:', error);
    } finally {
      this.loadingMarkers = false;
    }
  }




  fitRoute() {
    this.isAutoFollowPaused = true;
    this.isUserZooming = false;
    if (this.dragResumeTimeout) {
      clearTimeout(this.dragResumeTimeout);
    }

    if (!this.map?.googleMap) return;

    const bounds = new google.maps.LatLngBounds();
    let hasPoints = false;

    // 1. Extend bounds by all route points
    if (this.originalPoints && this.originalPoints.length > 0) {
      this.originalPoints.forEach(point => bounds.extend(point));
      hasPoints = true;
    }

    // 2. Extend bounds by destination marker
    if (this.backendDestinationMarker) {
      bounds.extend(this.backendDestinationMarker.getPosition() as google.maps.LatLng);
      hasPoints = true;
    }

    // 3. Extend bounds by current center (truck position)
    if (this.center) {
      bounds.extend(this.center);
      hasPoints = true;
    }

    if (hasPoints) {
      this.map.googleMap.fitBounds(bounds);
    }
  }

  reCenterMap() {
    if (this.dragResumeTimeout) {
      clearTimeout(this.dragResumeTimeout);
    }
    this.isAutoFollowPaused = false;
    this.isUserZooming = false;

    // First, try to find the exact marker we are tracking right now
    const trackingId = this.currentFollowDriverId || this.locateDriverids || this.driverId;
    const trackedMarker = this.markerOverlays?.find(o => String(o.id) === String(trackingId));

    let targetCenter = this.center;

    if (trackedMarker && trackedMarker.position) {
      targetCenter = trackedMarker.position;
      this.center = targetCenter; // Sync state
    } else if (this.initialCoordinates && (!this.center || (this.center.lat === 0 && this.center.lng === 0))) {
      // If we don't have the driver's position yet, fall back to the bounding box or destination
      targetCenter = this.initialCoordinates;
      this.center = targetCenter;
    }

    if (targetCenter && this.map?.googleMap && targetCenter.lat !== 0) {
      this.map.googleMap.panTo(targetCenter);
      const currentZoom = this.map.googleMap.getZoom() || 15;
      if (currentZoom < 16) {
        this.map.googleMap.setZoom(18);
      }
    }
  }

  getDriverName(id: any) {
    let label = '';
    // First try the current list
    this.listOfDrivers?.forEach((elt: any) => {
      if (elt.id == id) {
        label = elt.first_name + " " + elt.last_name;
      }
    });

    // Fallback to the master list if the current list is rebuilding during a tab switch
    if (!label && this.allDrivers) {
      this.allDrivers.forEach((elt: any) => {
        if (elt.id == id) {
          label = elt.first_name + " " + elt.last_name;
        }
      });
    }

    return label.toString();
  }
  getDefaultBounds(markers: any) {
    if (!markers || markers.length === 0) {
      // Fallback if no markers exist
      return { north: 43.651070, south: 43.651070, east: -79.347015, west: -79.347015 };
    }

    let north;
    let south;
    let east;
    let west;

    for (const marker of markers) {
      const lat = marker.position.lat;
      const long = marker.position.lng;

      north = north !== undefined ? Math.max(north, lat) : lat;
      south = south !== undefined ? Math.min(south, lat) : lat;
      east = east !== undefined ? Math.max(east, long) : long;
      west = west !== undefined ? Math.min(west, long) : long;
    }

    return { north, south, east, west };
  }

  getBounds(markers: any) {
    let north;
    let south;
    let east;
    let west;

    for (const marker of markers) {
      // set the coordinates to marker's lat and lng on the first run.
      // if the coordinates exist, get max or min depends on the coordinates.
      north = north !== undefined ? Math.max(north, marker.position.lat) : marker.position.lat;
      south = south !== undefined ? Math.min(south, marker.position.lat) : marker.position.lat;
      east = east !== undefined ? Math.max(east, marker.position.lng) : marker.position.lng;
      west = west !== undefined ? Math.min(west, marker.position.lng) : marker.position.lng;
    };

    const bounds = { north, south, east, west };

    return bounds;
  }

  // Hide call button if the phone number is all 8s or all 9s
  isValidPhoneNumber(phone: any): boolean {
    if (!phone) return false;
    const phoneStr = String(phone).replace(/\D/g, '');
    if (!phoneStr) return false;
    if (/^8+$/.test(phoneStr) || /^9+$/.test(phoneStr)) return false;
    return true;
  }

  openInfoWindow(marker: any) {

    this.router.navigate(['/admin/driver/details', marker.id]);
  }
  orderData: any
  driverss: any;
  countOrder: any;
  showZeroOrder: boolean = false;
  handleSubmit(event: any, marker: any) {
    const id = marker.id;
    this.driverss = marker?.label?.text;

    // 🔹 On locate-driver screen, confirm before navigating to prevent accidental clicks
    const currentUrl = this.router.url;
    if (currentUrl.includes('locate-driver')) {
      const driverName = marker?.label?.name || marker?.label?.text || 'this driver';
      const dialogRef = this.dialog.open(ConfirmNavigationDialogComponent, {
        width: '90%',
        maxWidth: '400px',
        panelClass: 'custom-modal-visible',
        disableClose: true,
        data: { driverName }
      });
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.router.navigate(['admin/driver/detail/orders', id]);
          this.dialog.closeAll();
          this.showOrdersList(marker);
        }
      });
      return;
    }

    this.router.navigate(['admin/driver/detail/orders', id]);

    this.dialog.closeAll();

    this.showOrdersList(marker);

  }
  showOrdersList(marker: any) {
    const id = marker.id;
    let enterAnimationDuration, exitAnimationDuration = '250ms';
    // const dialogRef = this.dialog.open(DialogAnimationsComponent, {
    //   height: '500px',
    //   enterAnimationDuration,
    //   exitAnimationDuration,
    //   panelClass: 'order-detail',
    //   data: {
    //     title: "Today's order",
    //     pageName: 'driver-details',
    //     btns:['','Close'],
    //     driverData: {
    //       id: id,
    //       status: "today",
    //       isDriverDetailsPage: true,
    //       isShowDropdownValues: false,
    //       isShowAssignedCount: false
    //     },
    //   },
    // });
    // dialogRef.afterClosed().subscribe((dialogResult: any) => {
    //   if (dialogResult) {

    //   }
    // });
  }

  trimPolyline(currentPos: google.maps.LatLng) {
    if (!this.originalPoints || this.originalPoints.length === 0) return;

    let searchStartIndex = this.lastClosestIndex > 3 ? this.lastClosestIndex - 3 : 0;
    let searchEndIndex = searchStartIndex + 20;
    if (searchEndIndex > this.originalPoints.length) {
      searchEndIndex = this.originalPoints.length;
    }

    let closestIndex = this.lastClosestIndex;
    let minDistance = Infinity;

    for (let i = searchStartIndex; i < searchEndIndex; i++) {
      const point = this.originalPoints[i];
      const dx = currentPos.lat() - point.lat();
      const dy = currentPos.lng() - point.lng();
      const dist = dx * dx + dy * dy;

      if (dist < minDistance) {
        minDistance = dist;
        closestIndex = i;
      }
    }

    // Check actual Haversine distance
    const closestPoint = this.originalPoints[closestIndex];
    let actualDistanceInMeters = 0;

    if (window.google && (google.maps as any).geometry) {
      actualDistanceInMeters = (google.maps as any).geometry.spherical.computeDistanceBetween(currentPos, closestPoint);
    } else {
      // Fallback rough estimate if geometry library not loaded
      actualDistanceInMeters = Math.sqrt(minDistance) * 111320;
    }

    if (actualDistanceInMeters > 500) {
      this.offRouteCounter++;
      if (this.offRouteCounter >= 3) {
        this.isOffRoute = true;
      }
    } else {
      this.offRouteCounter = 0;
      this.isOffRoute = false;
    }

    this.lastClosestIndex = closestIndex;

    this.ngZone.run(() => {
      this.trimmedRoutePath = this.originalPoints.slice(closestIndex);
      this.cdRef.detectChanges();
    });
  }

  // clear drawn backend route (poly/marker)
  clearBackendRoute() {
    this.trimmedRoutePath = [];
    if (this.backendDestinationOverlay) {
      this.backendDestinationOverlay.setMap(null);
      this.backendDestinationOverlay = null;
    }
    if (this.backendDestinationMarker) {
      this.backendDestinationMarker.setMap(null);
      this.backendDestinationMarker = null;
    }
    if (this.destinationMarker) {
      this.destinationMarker.setMap(null);
      this.destinationMarker = undefined;
    }
  }

  drawDriverRouteFromBackend(fallbackDriverLatLng?: google.maps.LatLngLiteral) {
    this.clearBackendRoute();

    if (!this.selectedDriverOrderData || !window.google || !this.mapDirectionsService) {
      return;
    }

    const orderData = this.selectedDriverOrderData;
    console.log("Drawing route for order data:", orderData);

    // The backend payload does NOT include a 'polyline' string, but it gives destination lat/lng.
    // We will use Google Maps Directions API ONLY to fetch the route line, but we will ignore its
    // calculated time/distance and display the backend's exact ETA and Distance in the UI instead.

    if (orderData.destination && orderData.destination.latitude && orderData.destination.longitude) {
      const trackingId = this.currentFollowDriverId || this.locateDriverids || this.driverId;
      const destLatLng = { lat: Number(orderData.destination.latitude), lng: Number(orderData.destination.longitude) };

      // Ensure we query RTDB for the absolute freshest starting point so the route perfectly matches the truck
      this.locateDriverService.getDriversInfo().then((res: any) => {
        let originLatLng: google.maps.LatLngLiteral | undefined;
        const driverMarker = this.markerOverlays.find(o => String(o.id) === String(trackingId));

        if (driverMarker) {
          originLatLng = driverMarker.position;
        } else if (res && res.length > 0) {
          const freshDriver = res.find((element: any) => String(element.driver_id) === String(trackingId));
          if (freshDriver && freshDriver.location) {
            originLatLng = { lat: Number(freshDriver.location.latitude), lng: Number(freshDriver.location.longitude) };
          }
        }

        if (!originLatLng && fallbackDriverLatLng) {
          originLatLng = fallbackDriverLatLng;
        }

        if (!originLatLng) {
          // If we don't know where the driver is yet, at least center the map on the destination!
          console.warn("Driver location unknown. Centering map on destination.");
          this.initialCoordinates = destLatLng;
          if (this.map?.googleMap) {
            this.map.googleMap.setCenter(destLatLng);
            this.map.googleMap.setZoom(14);
          }
        } else {
          const request: google.maps.DirectionsRequest = {
            origin: originLatLng,
            destination: destLatLng,
            travelMode: google.maps.TravelMode.DRIVING
          };

          this.ngZone.run(() => {
            this.mapDirectionsService.route(request).subscribe((response: any) => {
              if (response && response.result && response.result.routes && response.result.routes.length > 0) {
                this.originalPoints = response.result.routes[0].overview_path;
                this.trimmedRoutePath = [...this.originalPoints];
                this.lastClosestIndex = 0;
                this.isOffRoute = false;
                this.offRouteCounter = 0;

                // Zoom and center the map to fit the route exactly
                const bounds = new google.maps.LatLngBounds();
                bounds.extend(originLatLng!);
                bounds.extend(destLatLng);
                this.originalPoints.forEach((pt: any) => bounds.extend(pt));

                // ALWAYS update the initialCoordinates mathematically so the map loads in the exact right spot
                this.initialCoordinates = bounds.getCenter().toJSON();

                if (this.map?.googleMap) {
                  this.map.googleMap.fitBounds(bounds, { top: 50, bottom: 50, left: 50, right: 50 });
                }
              }
              this.cdRef.detectChanges();
            });
          });
        }

        // Draw a custom destination pin
        if (window.google) {
          const isPickup = orderData.order_type && orderData.order_type.toLowerCase() === 'pickup';
          const isWarehouse = orderData.order_type && orderData.order_type.toLowerCase() === 'warehouse';

          let pinColor = '#008A51'; // Delivery green
          let pinLabel = 'D';

          if (isPickup) {
            pinColor = '#DB2777'; // Pickup pink
            pinLabel = 'P';
          } else if (isWarehouse) {
            pinColor = '#1e40af'; // Warehouse blue
            pinLabel = 'W';
          }

          const svgMarker = {
            path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z",
            fillColor: pinColor,
            fillOpacity: 1,
            strokeWeight: 1.5,
            strokeColor: '#ffffff',
            scale: 2.2,
            anchor: new google.maps.Point(12, 22),
            labelOrigin: new google.maps.Point(12, 9) // Centers the P or D inside the top bubble
          };

          this.backendDestinationMarker = new (google as any).maps.Marker({
            position: destLatLng,
            map: this.map?.googleMap,
            title: 'Destination',
            icon: svgMarker,
            label: {
              text: pinLabel,
              color: 'white',
              fontSize: '13px',
              fontWeight: 'bold'
            }
          });

          // Add the compact floating address label using OverlayView
          const address = orderData.destination.address || 'Destination';
          const shortAddress = address.length > 50 ? address.substring(0, 50) + '...' : address;

          const div = document.createElement('div');
          div.style.position = 'absolute';
          div.style.background = 'white';
          div.style.padding = '4px 8px';
          div.style.borderRadius = '6px';
          div.style.boxShadow = '0 2px 8px rgba(0,0,0,0.2)';
          div.style.border = '1px solid #cbd5e1';
          div.style.fontSize = '11px';
          div.style.fontWeight = '600';
          div.style.color = '#1e293b';
          div.style.whiteSpace = 'nowrap';
          div.style.transform = 'translate(-50%, -100%)';
          // offset above the marker icon (icon is 40px, plus a small gap)
          div.style.marginTop = '-45px';
          div.innerText = shortAddress;

          const overlay = new google.maps.OverlayView();
          overlay.onAdd = function () {
            const panes = this.getPanes();
            if (panes) {
              panes.overlayMouseTarget.appendChild(div);
            }
          };
          overlay.draw = function () {
            const projection = this.getProjection();
            if (!projection) return;
            const pos = projection.fromLatLngToDivPixel(new google.maps.LatLng(destLatLng));
            if (pos) {
              div.style.left = `${pos.x}px`;
              div.style.top = `${pos.y}px`;
            }
          };
          overlay.onRemove = function () {
            if (div.parentNode) {
              div.parentNode.removeChild(div);
            }
          };

          if (this.map?.googleMap) {
            overlay.setMap(this.map.googleMap);
          }
          this.backendDestinationOverlay = overlay;
        }
      }); // Close the locateDriverService.getDriversInfo().then() block
    } else {
      console.warn("Missing destination latitude/longitude in running_order.");
    }
  }

  getDistance(originOne: any, originOneName: any, originTwo: any, originTwoName: any) {
    const directionsService = new google.maps.DirectionsService();
    const origin1 = originOne;
    const origin2 = "Greenwich, England";
    const destinationA = "Kadapa";
    const destinationB = originTwo;

    const request = {
      origin: origin1,
      destination: destinationB,
      travelMode: google.maps.TravelMode.DRIVING
    };

    directionsService.route(request, (response: any, status: any) => {
      if (status === 'OK') {
        const route = response.routes[0];
        const lastIndex = route.legs.length - 1;
        if (lastIndex >= 0) {
          console.log(route);
          this.estimatedTime = route.legs[lastIndex].duration.text;
          this.distance = route.legs[lastIndex].distance.text;
        } else {
          // Handle the case where legs array is empty
          this.estimatedTime = "N/A";
          this.distance = "N/A";
        }
      } else {
        // Handle the error status, e.g., 'ZERO_RESULTS', 'NOT_FOUND', etc.
        console.error('Directions request failed due to ' + status);
      }
    });
  }
  myFunction(title: any, functionName: any) {
    try {
      throw new Error('GOOGLE API HIT');
    } catch (error: any) {
      // Handle the error gracefully
      this.loggingService.error(error.message, error, title, functionName);
      // You can also perform additional actions like logging or displaying a user-friendly error message
    }
  }
  modalLeft = 0;
  modalTop = 0;
  isDragging = false;
  startX = 0;
  startY = 0;


  dragStart(event: MouseEvent | TouchEvent) {
    if (event instanceof MouseEvent && event.button !== 0) { // Right mouse button
      return;
    }
    event.preventDefault();
    let clientX = 0;
    let clientY = 0;
    if (event instanceof MouseEvent) {
      clientX = event.clientX;
      clientY = event.clientY;
    } else if (event instanceof TouchEvent) {
      const touch = event.touches[0];
      clientX = touch.clientX;
      clientY = touch.clientY;
    }
    const modalDialog = this.elRef.nativeElement.querySelector('.modal-dialog');
    const startX = clientX - modalDialog.getBoundingClientRect().left;
    const startY = clientY - modalDialog.getBoundingClientRect().top;

    const moveHandler = (e: MouseEvent | TouchEvent) => {
      e.preventDefault();
      let moveClientX = 0;
      let moveClientY = 0;
      if (e instanceof MouseEvent) {
        moveClientX = e.clientX;
        moveClientY = e.clientY;
      } else if (e instanceof TouchEvent) {
        const touch = e.touches[0];
        moveClientX = touch.clientX;
        moveClientY = touch.clientY;
      }
      modalDialog.style.left = moveClientX - startX + 'px';
      modalDialog.style.top = moveClientY - startY + 'px';
    };

    const stopHandler = () => {
      document.removeEventListener('mousemove', moveHandler);
      document.removeEventListener('touchmove', moveHandler);
      document.removeEventListener('mouseup', stopHandler);
      document.removeEventListener('touchend', stopHandler);
    };

    document.addEventListener('mousemove', moveHandler);
    document.addEventListener('touchmove', moveHandler);
    document.addEventListener('mouseup', stopHandler);
    document.addEventListener('touchend', stopHandler);
  }

  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }
}

// 🔹 Inline confirmation dialog for locate-driver marker click
// Matches SendNotificationDialogComponent style (modal-header/body/footer, Epilogue title, green btn-primary)
@Component({
  selector: 'confirm-navigation-dialog',
  template: `
    <div class="modal-header">
      <h2 mat-dialog-title class="modal-title">Navigate to Driver Orders?</h2>
      <button class="btn-close" (click)="onCancel()" aria-label="Close dialog">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <mat-dialog-content class="modal-body">
      <div class="form-group mb-0">
        <p class="confirm-message">
          You are about to view orders for
          <strong class="driver-name">{{data.driverName}}</strong>.
        </p>

      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="modal-footer">
      <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
      <button class="btn btn-primary" (click)="onConfirm()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="icon-sm">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
        </svg>
        View Orders
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    :host { display: block; }
    .modal-header {
      display: flex; align-items: center; justify-content: space-between;
      padding: 20px 24px; background: white; border-bottom: 1px solid #f1f5f9;
    }
    .modal-title {
      margin: 0 !important; font-family: 'Epilogue', sans-serif;
      font-size: 18px; font-weight: 700; color: #0f172a;
    }
    .btn-close {
      width: 32px; height: 32px; display: flex; align-items: center; justify-content: center;
      border-radius: 8px; border: none; background: transparent; color: #94a3b8;
      cursor: pointer; transition: all 0.2s;
    }
    .btn-close:hover { background: #f8fafc; color: #475569; }
    .btn-close svg { width: 20px; height: 20px; }
    .modal-body { padding: 24px !important; margin: 0 !important; max-height: none !important; }
    .form-group { display: flex; flex-direction: column; gap: 6px; }
    .confirm-message { margin: 0; font-size: 14px; color: #334155; line-height: 1.6; font-family: 'Inter', sans-serif; }
    .driver-name { font-weight: 700; color: #0f172a; }
    .form-helper { margin: 6px 0 0 0; font-size: 12px; color: #94a3b8; line-height: 1.5; }
    .modal-footer {
      display: flex !important; align-items: center; justify-content: flex-end;
      gap: 12px; padding: 16px 24px 24px 24px !important; margin: 0 !important;
    }
    .btn {
      height: 44px; padding: 0 20px; border-radius: 10px; font-family: 'Inter', sans-serif;
      font-size: 14px; font-weight: 600; display: inline-flex; align-items: center;
      justify-content: center; gap: 8px; cursor: pointer; transition: all 0.2s; border: none;
    }
    .btn-secondary {
      background: white; border: 1px solid #e2e8f0; color: #475569;
    }
    .btn-secondary:hover { background: #f8fafc; border-color: #cbd5e1; color: #1e293b; }
    .btn-primary {
      background: linear-gradient(135deg, #00a862, #008a51);
      color: white; box-shadow: 0 4px 12px rgba(0, 168, 98, 0.2);
    }
    .btn-primary:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(0, 168, 98, 0.3); }
    .btn-primary:active { transform: translateY(0); }
    .icon-sm { width: 18px; height: 18px; }
    .mb-0 { margin-bottom: 0 !important; }
  `],
  standalone: true,
  imports: [MatDialogModule]
})
export class ConfirmNavigationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmNavigationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { driverName: string }
  ) { }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
